import {
  Box,
  Tooltip,
  Typography,
  Paper,
  Chip,
  Skeleton,
  useMediaQuery,
  Divider,
  FormControlLabel,
  Switch,
  DialogTitle,
  Grid,
  Dialog,
  styled,
  DialogContent,
  DialogActions,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  IconButton,
  CircularProgress,
  Avatar,
  useTheme,
  Badge
} from '@mui/material';
import { SetStateAction, useCallback, useEffect, useLayoutEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../../app/redux/hooks';
import CustomDataGrid from '../../../../../common/components/customized/customdatagrid/CustomDataGrid';
import {
  autoGenerateUpdateTripsAction,
  clearExcelView,
  clearWhatsapp,
  getExcelAction,
  guestContactUpdateAction,
  getStandardDriverNames,
  getStandardVehicles,
  PvtGrpUpdate,
  sendwhatsappAction,
  sicBookingsUpdate,
  clearDriverNames
} from '../../../redux/reducer/autoPlannerSlices/autoGenerateSlice';
import CustomTextField from '../../../../../common/components/customized/customtextfield/CustomTextField';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import { Controller, useForm } from 'react-hook-form';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import nodata from '../../../../../app/assets/images/nodata.png.png';
import EditIcon from '@mui/icons-material/Edit';
import * as yup from 'yup';
import {
  capitalizeFirstLetter,
  convertEpoctoTimeZoneDate,
  debounce,
  epochToTimeFormat,
  getTodayEpoch,
  useAbort
} from '../../../../../utils/commonFunctions';
import { Icon } from '@iconify/react';
import { getMyProfileAction } from '../../../../../common/redux/reducer/commonSlices/myProfileSlice';
import './TodayTour.scss';
import {
  clearTodayTour,
  getTodayTours
} from '../../../redux/reducer/autoPlannerSlices/todayToursSlice';
import CustomButton from '../../../../../common/components/buttons/CustomButton';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import TourDashboard from './TourDashboard';
import PhoneNoTextField from '../../../../../common/components/customized/customtextfield/PhoneNoTextField';
import { yupResolver } from '@hookform/resolvers/yup';
import constant from '../../../../../utils/constants';
import { log } from 'util';
import CustomSelect from '../../../../../common/components/customized/customselect/CustomSelect';
import { Check, Close, DirectionsCar } from '@mui/icons-material';
import { Any } from 'react-spring';
import CustomRadioButton from '../../../../../common/components/customized/customradiobutton/CustomRadioButton';
import {
  autoPlannerAgentAction,
  autoPlannerDeleteAction,
  clearContactError,
  contactNumberValidation,
  GetGrpBookings
} from '../../../redux/reducer/autoPlannerSlices/autoplanner';
import { debounce as Debounce } from 'lodash';
import AddAdhocTrip from '../bookings/components/AddAdhocTrip';
import PostAddIcon from '@mui/icons-material/PostAdd';
import { GridActionsCellItem } from '@mui/x-data-grid';
import AssignmentTurnedInOutlinedIcon from '@mui/icons-material/AssignmentTurnedInOutlined';
import ViewAdhocRequests from './components/ViewAdhocRequests';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import DirectionsCarFilledOutlinedIcon from '@mui/icons-material/DirectionsCarFilledOutlined';

// const schema: any = () =>
//   yup.object().shape({
//     phone: yup.string().required('Enter contact number')
//   });

const TodayTours = () => {
  const [rows, setRows] = useState([]);
  const [rowCount, setRowCount] = useState(0);
  const [invalidRows, setInvalidRows] = useState([]);
  const [PageSize, setPageSize] = useState(20);
  const [open, setOpen] = useState(false);
  const [PageNo, setPageNo] = useState(1);
  const [filter, setFilter] = useState('');
  const [selectedRow, setSelectedRow] = useState<any>('');
  const [zone, setZone] = useState<boolean>(true);
  const [searchEvent, setSearchEvent] = useState<any>('');
  const [scheduleDate, setScheduleDate] = useState<number>(0);
  const [timeZone, setTimeZone] = useState<string>('UTC');
  const [refresh, setRefresh] = useState(false);
  const [groupView, setGroupView] = useState(true);
  const [hotelGuestView, setHotelGuestView] = useState(null);
  const [isDialog, setIsDialog] = useState<any>('');
  const [selectedTripRow, setSelectedTripRow] = useState<any | null>(null);
  const [sendWhatsApp, setSendWhatsApp] = useState(false);
  const [guestContactList, setGuestContactList] = useState<
    { autoplannerID: number; guestContactNumber: string; journyId: string }[]
  >([]);

  const [external, setExternal] = useState<boolean>(false);
  const [validationErrors, setValidationErrorsMake] = useState<any>({
    driverNumber: '',
    phone: ''
  });

  const [callApi, setCallApi] = useState<boolean>(false);
  const [refreshLoader, setRefreshLoader] = useState<boolean>(false);
  const [isViewAdhoc, setIsViewAdhoc] = useState<boolean>(false);
  const [badgeCount, setBadgeCount] = useState<number>(0);
  const { data, count, isLoading, statusCount } = useAppSelector(state => state.getExcel);
  const { data: ViewAdhocReqData } = useAppSelector(state => state.tripGRP);
  const Agents = useAppSelector(state => state.autoPlannerAgent.data || []);

  const { isLoading: updateGuestLoading } = useAppSelector(state => state.contactguest);

  const { isLoading: onsubmitIsLoading } = useAppSelector(
    state => state.AutoGeneratedUpdateTrip
  );
  const { data: vehicleDropdown, isLoading: dropdownLoading } = useAppSelector(
    state => state.getStandardVehicles
  );

  const { data: DriverNames, isLoading: DriverNameLoading } = useAppSelector(
    state => state.getStandardDriverNames
  );

  const { isLoading: updatePVTLoading } = useAppSelector(
    state => state.updatePvtGrpScheduled
  );

  const { isLoading: sicIsLoading } = useAppSelector(state => state.sicBookingsUpdate);
  const contactError = useAppSelector(state => state.ContactNumberValidation);

  const autoplannerID = scheduleDate;

  const { control: phoneControl, setValue: settingValue, reset } = useForm({});

  const {
    data: groupData,
    count: groupCount,
    statusCount: groupStatusCount,
    isLoading: groupStatusLoading
  } = useAppSelector((state: any) => state.todayTours);

  const profileData = useAppSelector(
    state => state.myProfile.data || { timezone: '', userName: '' }
  );
  const sendwhatsapp = useAppSelector(state => state.sendwhatsapp);

  const { data: roles } = useAppSelector(state => state.auth);

  const standardVehicles =
    vehicleDropdown?.length > 0
      ? vehicleDropdown?.map((value: string, index: number) => ({
          id: value,
          label: value?.toUpperCase()
        }))
      : [];

  const driverNameDropdown =
    DriverNames?.length > 0
      ? DriverNames?.map((value: any) => ({
          ...value,
          id: value?.driverID,
          label: value?.driverName?.toUpperCase()
        }))
      : [];
  const defaultVehilceNumber = [
    {
      id: selectedRow?.vehicleNumber,
      label: selectedRow?.vehicleNumber?.toUpperCase()
    }
  ];

  const AssignVehicleIcon = () => (
    <Box sx={{ position: 'relative', display: 'inline-flex' }}>
      <DirectionsCarFilledOutlinedIcon sx={{ fontSize: 28, color: '#0d9488' }} />
      <AddCircleOutlineIcon
        sx={{
          fontSize: 14,
          color: '#0d9488',
          position: 'absolute',
          bottom: -2,
          right: -6,
          backgroundColor: '#fff',
          borderRadius: '50%'
        }}
      />
    </Box>
  );

  const vehicleSchema = yup.object().shape({
    vehicle: yup
      .string()
      .oneOf(['internal', 'external'])
      .required('Select vehicle type')
      .default('internal'),
    vehicleNumber: yup.string().when('vehicle', {
      is: 'internal',
      then: () => yup.string().required('Select vehicle number'),
      otherwise: () =>
        yup

          .string()
          .required('Enter vehicle number')
          .matches(/^[A-Za-z0-9]*$/, 'Only letters and numbers allowed without spaces')
          .test(
            'valid-length',
            'Enter a valid vehicle number',
            value => (value?.length || 0) >= 4
          )
          .max(20, 'Maximum 20 characters')
          .test('has-letter', 'Must include at least one letter', value =>
            /[A-Za-z]/.test(value || '')
          )
    }),
    driverName: yup.string().when('vehicle', {
      is: 'external',
      then: () =>
        yup
          .string()
          .required('Enter driver name')
          .min(3, 'Driver name must be more than 2 characters')
          .matches(/^[a-zA-Z\s]+$/, 'Driver name must only contain characters'),
      otherwise: () => yup.string().required('Select driver name')
    }),
    passengerCount: yup.string().when('vehicle', {
      is: 'external',
      then: () =>
        yup
          .number()
          .required('Enter seating capacity')
          .min(
            selectedRow?.netCount ? selectedRow?.netCount : 1,
            `Seat Capacity Must be Minimum ${
              selectedRow?.netCount ? selectedRow?.netCount : 1
            }`
          )
          .max(249, 'Maximum absolute seating is 249')
          .transform((value, originalValue) => {
            return originalValue === '' ? undefined : value;
          })
          .typeError('Enter valid absolute seating'),

      otherwise: () => yup.string().notRequired()
    }),
    driverNumber: yup.string().when('vehicle', {
      is: 'external',
      then: () =>
        yup
          .string()
          .trim()
          .required('Enter contact number')
          .min(8, 'Enter valid contact number')
          .test('is-number', 'Enter contact number', function (value: any) {
            return value;
          })
          .test('phone-error', 'Enter valid contact number', function (value: any) {
            if (value && validationErrors?.driverNumber !== 'no-error') {
              return this.createError({ message: validationErrors?.driverNumber });
            } else {
              return true;
            }
          }),
      otherwise: () => yup.string().notRequired()
    })
  });

  let roleType = roles?.role;
  const { category } = useAppSelector(state => state.RoleModuleAccess);

  const APsuperAdmin = roleType === 'ROLE_AUTOPLANNER_ADMIN';
  const APoperator = roleType === 'ROLE_OPERATOR';
  const APagent = roleType === 'ROLE_AGENT';
  const APsubAgent = roleType === 'ROLE_SUB_AGENT';

  const isAP = APsuperAdmin || APoperator || APagent || category === 'OPERATION_USER';

  const profileLoading = useAppSelector(state => state.myProfile.isLoading);
  const AutoPlannerDeleteTripLoading = useAppSelector(
    state => state.AutoPlannerDeleteTrip.isLoading
  );
  const PVTGRPUpdateLoading = useAppSelector(
    state => state.updatePvtGrpScheduled.isLoading
  );

  const theme = useTheme();
  const isMdUp = useMediaQuery(theme.breakpoints.up('md'));

  const {
    control,
    handleSubmit: vehicelsubmit,
    getValues,
    setValue: setVehicleValue,
    trigger,
    reset: externalReset,
    clearErrors: clearExternalVehicleErrors,
    formState: { errors: vehicleErrors }
  } = useForm({
    // defaultValues: {
    //   vehicle: 'internal'
    // },
    resolver: yupResolver(vehicleSchema)
  });

  const defaultDriverName = [
    {
      id:
        selectedRow?.standardTourOverview?.driverID ||
        selectedRow?.customTourOverview?.driverID ||
        '',

      label:
        selectedRow?.standardTourOverview?.driverName?.toUpperCase() ||
        selectedRow?.customTourOverview?.driverName?.toUpperCase() ||
        ''
    }
  ];

  const schema: any = () =>
    yup.object().shape({
      phone: yup
        .string()
        .trim()
        .required('Enter contact number')
        .min(8, 'Enter valid contact number')
        .test('is-number', 'Enter contact number', function (value: any) {
          return value;
        })
        .test('phone-error', 'Enter valid contact number', function (value: any) {
          if (validationErrors?.phone && value && validationErrors.phone !== 'no-error') {
            return this.createError({ message: validationErrors.phone });
          } else {
            return true;
          }
        })
    });

  const createAbort = useAbort();
  const isSm = useMediaQuery('(max-width:700px)');
  const isXs = useMediaQuery('(max-width:575px');
  const isShare = useMediaQuery('(max-width:595px)');

  const dispatch = useAppDispatch();
  const agentNames =
    Agents?.map((value: string) => ({
      id: value,
      label: capitalizeFirstLetter(value)
    })) || [];

  const {
    control: formControl,
    setValue,
    reset: restToggle,
    trigger: phoneTrigger,
    formState: { errors },
    clearErrors,
    reset: internalReset,
    handleSubmit: onsubmit
  } = useForm({ resolver: yupResolver(schema()) });

  const handleOpenDialog = async (row: any) => {
    setCallApi(true);
    setSelectedRow(row);
    if (!row) return;

    const mode = row?.mode;
    let overview = null;

    if (['SIC', 'TSIC'].includes(mode)) {
      overview = row?.standardTourOverview;
    } else if (['PVT', 'GRP'].includes(mode)) {
      overview = row?.customTourOverview;
    }
    const isExternal = overview?.isExternalVehicle === 1;
    setExternal(isExternal);

    setVehicleValue('vehicle', isExternal ? 'external' : 'internal');

    if (isExternal) {
      setVehicleValue(
        'vehicleNumber',
        overview?.vehicleNumber === 'Unassigned' ? '' : overview?.vehicleNumber || ''
      );
      setVehicleValue(
        'driverName',
        overview?.driverID === 'Unassigned' ? '' : overview?.driverID || ''
      );

      setVehicleValue(
        'driverNumber',
        overview?.contactNumber === 'Unassigned' ? '' : overview?.contactNumber || ''
      );
      setVehicleValue('passengerCount', overview?.seatingCapacity || '');
    } else {
      setVehicleValue(
        'vehicleNumber',
        overview?.vehicleNumber === 'Unassigned' ? '' : overview?.vehicleNumber || ''
      );
      setVehicleValue(
        'driverName',
        overview?.driverID === 'Unassigned' ? '' : overview?.driverID || ''
      );
      setVehicleValue(
        'driverNumber',
        overview?.contactNumber === 'Unassigned' ? '' : overview?.contactNumber || ''
      );

      setVehicleValue('passengerCount', overview?.seatingCapacity || '');
    }

    const payload = {
      autoplannerID: row.date,
      tripMode: row?.mode,
      tourName: row?.tourName,
      totalPassengers: row?.totalGuests,
      vehicleNumber: row?.vehicleNumber,
      isCurrentSchedule: true,
      journeyId: overview?.journeyId || overview?.journeyId || ''
    };

    setOpen(true);
    if (!isExternal) {
      dispatch(getStandardVehicles(payload));
      if (row?.vehicleNumber !== 'Unassigned') {
        dispatch(getStandardDriverNames(payload));
      }
    }
  };

  const handleCancel = () => {
    setCallApi(false);
    setOpen(false);
    setValidationErrorsMake({ driverNumber: 'no-error', phone: 'no-error' });
    clearExternalVehicleErrors();
    internalReset();
    externalReset();
  };
  const onvehicleSubmit = async (params: any) => {
    const isPVTGRP = ['PVT', 'GRP']?.includes(selectedRow?.mode);
    // const isSICTSIC = ['SIC', 'TSIC'].includes(selectedRow?.mode);
    const external = params?.vehicle === 'external';

    // const isStandard = selectedRow.standardTourOverview !== null;
    const SICTSICPayload = {
      id: selectedRow.standardTourOverview?.id || selectedRow.id,
      tourName: selectedRow.standardTourOverview?.tourName || selectedRow.tourName,
      pickupWindow: selectedRow.standardTourOverview?.pickupWindow,
      returnTime: selectedRow.standardTourOverview?.returnTime,
      totalAdultCount: selectedRow.standardTourOverview?.totalAdultCount,
      totalChildCount: selectedRow.standardTourOverview?.totalChildCount || 0,
      netCount: selectedRow.standardTourOverview?.netCount,
      isExternalVehicle: external ? 1 : 0,
      isReturnTrip: selectedRow.standardTourOverview?.isReturnTrip || 0,
      modifyVehicleDriver: null,
      driverContactNumber: params?.driverNumber,

      //internal
      vehicleNumber: params?.vehicleNumber,
      driverID: params?.driverName || selectedRow.standardTourOverview?.driverID,
      driverName:
        driverNameDropdown?.find((value: any) => value?.id === params?.driverName)
          ?.driverName || params?.driverName,
      //external
      externalVehicleView: external
        ? {
            vehicleNumber: params?.vehicleNumber,
            driverName: params?.driverName,
            driverID:
              params?.driverName && params?.driverNumber
                ? `${params?.driverName}-${params?.driverNumber}`
                : null,
            mobileNumber: params?.driverNumber,
            seatingCapacity: params?.passengerCount
          }
        : null
    };

    const PVTGRPPayload = {
      agentName: selectedRow.customTourOverview?.agentName,
      guestName: selectedRow.customTourOverview?.guestName,
      source: selectedRow.customTourOverview?.source,
      startLat: selectedRow.customTourOverview?.startLat,
      startLng: selectedRow.customTourOverview?.startLng,
      destination: selectedRow.customTourOverview?.destination,
      endLat: selectedRow.customTourOverview?.endLat,
      endLng: selectedRow.customTourOverview?.endLng,
      time: selectedRow.customTourOverview?.time,
      childCount: selectedRow.customTourOverview?.childCount || 0,
      isCustomRoute: 1,

      adultCount: selectedRow.customTourOverview?.adultCount || 0,
      refNumber: selectedRow.customTourOverview?.refNumber || '',
      tourName: selectedRow.customTourOverview?.destination,

      isExternalVehicle: external ? 1 : 0,
      journeyId: selectedRow.customTourOverview?.journeyId,

      modifyVehicleDriver: null,

      //internal
      driverID: params?.driverName,
      driverName:
        driverNameDropdown?.find((value: any) => value?.id === params?.driverName)
          ?.driverName || params?.driverName,
      vehicleNumber: params?.vehicleNumber,
      // external
      seatingCapacity: params?.passengerCount,
      contactNumber: params?.driverNumber
    };

    const pageDetails = {
      autoplannerID: scheduleDate,
      tripMode: selectedRow?.mode,
      isCurrentSchedule: true
    };
    const payload = isPVTGRP ? PVTGRPPayload : SICTSICPayload;
    const datas = { payload, pageDetails, todatTrips: true };
    const action = await (!isPVTGRP
      ? dispatch(autoGenerateUpdateTripsAction(datas as any))
      : dispatch(PvtGrpUpdate(datas as any)));

    if (
      action.type === autoGenerateUpdateTripsAction.fulfilled.type ||
      action.type === PvtGrpUpdate.fulfilled.type
    ) {
      setOpen(false);
      const payload = {
        PageNo: 1,
        PageSize: PageSize,
        autoplannerID: scheduleDate,
        tripMode: 'ALL'
      };

      setPageNo(1);
      if (isOverview) {
        await dispatch(getTodayTours(payload));
      } else {
        await dispatch(getExcelAction(payload));
      }
    }
  };

  const AntSwitch = styled(Switch)(() => ({
    width: 28,
    height: 16,
    padding: 0,
    display: 'flex',

    '& .MuiSwitch-switchBase': {
      padding: 2,
      '&.Mui-checked': {
        transform: 'translateX(12px)',
        color: '#fff',
        '& + .MuiSwitch-track': {
          opacity: 1,
          backgroundColor: '#3239EA'
        }
      }
    },
    '& .MuiSwitch-thumb': {
      width: 12,
      height: 12,
      borderRadius: 6
    },
    '& .MuiSwitch-track': {
      borderRadius: 16 / 2,
      opacity: 1,
      backgroundColor: '#000',
      boxSizing: 'border-box'
    }
  }));

  const columns: any[] = [
    ...(!(APsubAgent || APagent)
      ? [
          {
            field: 'actions',
            headerName: 'Action',
            type: 'actions',
            minWidth: 60,
            maxWidth: 60,
            flex: 1,
            sortable: false,
            getActions: ({ row }: any) => {
              const isAdhoc =
                row?.isAdhoc && ['Upcoming', null]?.includes(row?.tripStatus);

              return isAdhoc
                ? [
                    <GridActionsCellItem
                      icon={
                        <Icon icon='mdi:pencil' height={18} width={18} color='#0d9488' />
                      }
                      label='Update'
                      onClick={(e: any) => {
                        e.stopPropagation();
                        setSelectedTripRow(row);
                        setIsDialog('adhoc');
                        setCallApi(true);
                      }}
                      sx={{
                        padding: '4px 8px',
                        borderRadius: '4px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        '&:hover': {
                          backgroundColor: '#f0fdfa'
                        }
                      }}
                      showInMenu
                    />
                  ]
                : [
                    <GridActionsCellItem
                      sx={{ marginLeft: '10px' }}
                      icon={
                        <Tooltip title='Only upcoming ad-hoc bookings are editable'>
                          <span>
                            <Icon
                              icon='ic:round-lock'
                              className='menu-icon update'
                              color='grey'
                              height='20'
                              width='20'
                            />
                          </span>
                        </Tooltip>
                      }
                      label='Not Editable'
                      // onClick={(e: any) => e.stopPropagation()}
                      // disabled
                    />
                  ];
            }
          }
        ]
      : []),

    {
      field: 'status',
      headerName: 'Status',
      minWidth: 100,
      maxWidth: 100,
      flex: 1,
      sortable: false,
      renderCell: ({ row }: any) => {
        const updateTime = row?.guestStatusChangeAt;
        return (
          <Tooltip
            enterDelay={200}
            leaveDelay={200}
            title={
              row?.isGuestArrived === 'Arrived'
                ? 'Onboarded'
                : row?.isGuestArrived === 'Not Arrived'
                ? 'No show'
                : row?.isGuestArrived === 'Skipped'
                ? 'Skipped'
                : 'Yet to board'
            }
          >
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Icon
                icon={
                  row?.isGuestArrived === 'Arrived'
                    ? 'mdi:tick-circle-outline'
                    : row?.isGuestArrived === 'Not Arrived'
                    ? 'mingcute:close-circle-line'
                    : row?.isGuestArrived === 'Skipped'
                    ? 'mdi:skip-next-circle-outline'
                    : 'ic:sharp-pending-actions'
                }
                height={18}
                width={18}
                style={{ marginRight: '10px' }}
                color={
                  row?.isGuestArrived === 'Arrived'
                    ? '#00b25c'
                    : row?.isGuestArrived === 'Not Arrived'
                    ? '#ff0004'
                    : row?.isGuestArrived === 'Skipped'
                    ? '#6c757d'
                    : 'orange'
                }
              />
              {updateTime === 0 ? '' : `${epochToTimeFormat(updateTime, timeZone)}`}
            </Box>
          </Tooltip>
        );
      }
    },
    {
      field: 'time',
      headerName: 'Time',
      minWidth: 100,
      maxWidth: 100,
      flex: 1,
      sortable: false,
      renderCell: (params: any) => {
        let timeStr = params.value;

        if (!timeStr) return '';

        let [hours, minutes] = timeStr.split(':').map(Number);
        let period = hours >= 12 ? 'PM' : 'AM';

        hours = hours % 12 || 12;

        return (
          <Tooltip
            enterDelay={200}
            leaveDelay={200}
            title={`${hours.toString().padStart(2, '0')}:${minutes
              .toString()
              .padStart(2, '0')} ${period}`}
          >
            <Chip
              label={`${hours.toString().padStart(2, '0')}:${minutes
                .toString()
                .padStart(2, '0')} ${period}`}
              size='small'
              sx={{
                backgroundColor: '#e3f2fd',
                color: '#1976d2',
                fontWeight: 'bold',
                fontSize: '0.75rem'
              }}
            />
          </Tooltip>
        );
      }
    },
    {
      field: 'agentName',
      headerName: 'Agent',
      minWidth: 150,
      flex: 1,
      sortable: false,
      renderCell: ({ row }: any) => {
        return (
          <Box component={'span'} sx={{ fontSize: '12px' }}>
            {row?.agentName ? capitalizeFirstLetter(row?.agentName) : '-'}
          </Box>
        );
      }
    },
    {
      field: 'mode',
      headerName: 'Mode',
      minWidth: 70,
      maxWidth: 70,
      flex: 1,
      sortable: false,
      renderCell: ({ row }: any) => {
        return (
          <Box component={'span'} sx={{ fontSize: '12px' }}>
            {row?.mode ? row?.mode?.toUpperCase() : '-'}
          </Box>
        );
      }
    },
    {
      field: 'refNumber',
      headerName: 'Ref No.',
      minWidth: 150,
      flex: 1,
      sortable: false,
      renderCell: (params: any) => (
        <Tooltip enterDelay={200} leaveDelay={200} title={params.value || ''}>
          <span style={{ fontSize: '12px' }}>{params.value ? params.value : '-'}</span>
        </Tooltip>
      )
    },
    {
      field: 'guestName',
      headerName: 'Guest',
      minWidth: 200,
      flex: 1,
      sortable: false,
      renderCell: (params: any) => (
        <Tooltip enterDelay={200} leaveDelay={200} title={params.value || ''}>
          <Typography
            noWrap
            sx={{ width: params?.value ? '200px' : '', fontSize: '12px' }}
          >
            {params.value ? capitalizeFirstLetter(params.value) : '-'}
          </Typography>
        </Tooltip>
      )
    },
    {
      field: 'guestContactNumber',
      headerName: 'Guest Contact No.',
      minWidth: 200,
      flex: 1,
      sortable: false,
      renderCell: (params: any) => {
        if (params.row?.mode === 'RLR') {
          return <Typography sx={{ fontSize: '0.75rem', fontWeight: 500 }}>-</Typography>;
        }

        const hasContactNumber = params.row?.driverContactNumber === 'null';
        // if (
        //   params?.row?.tripStatus === 'Completed' &&
        //   params?.row?.driverContactNumber === 'Unassigned'
        // ) {
        //   return <Typography sx={{ fontSize: '0.75rem', fontWeight: 500 }}>-</Typography>;
        // } else {
        //   return (
        //     <Box
        //       sx={{
        //         display: 'flex',
        //         alignItems: 'center',
        //         width: '100%',
        //         backgroundColor: hasContactNumber ? '#f1f8e9' : '#fff3e0',
        //         borderRadius: '8px',
        //         padding: '4px 8px',
        //         border: hasContactNumber ? '1px solid #8bc34a' : '1px solid #ff9800'
        //       }}
        //       onClick={event => {
        //         event.stopPropagation();
        //         setCallApi(true);
        //         setSelectedTripRow(params.row);
        //         setValue('phone', params?.row?.guestContactNumber);
        //         setIsDialog('AddContact');
        //       }}
        //     >
        //       <Icon
        //         icon={hasContactNumber ? 'ph:phone-plus' : 'ph:arrows-clockwise'}
        //         style={{
        //           color: hasContactNumber ? '#4CAF50' : '#ff9800',
        //           cursor: 'pointer',
        //           fontSize: '20px',
        //           marginRight: '8px',
        //           userSelect: 'none'
        //         }}
        //         className={'activeIcon'}
        //         onClick={() => {
        //           setCallApi(true);
        //           setIsDialog('AddContact');
        //         }}
        //       />

        //       <Typography
        //         sx={{ fontSize: '0.75rem', fontWeight: '500', cursor: 'pointer' }}
        //       >
        //         {params.row?.guestContactNumber || 'Add contact'}
        //       </Typography>
        //     </Box>
        //   );
        // }

        return params?.row?.isGuestArrived === 'Skipped' ||
          params?.row?.tripStatus === 'Completed' ? (
          <Tooltip
            enterDelay={200}
            leaveDelay={200}
            title={
              params?.row?.tripStatus === 'Completed'
                ? "Contact number can't be updated for completed bookings"
                : "Contact number can't be updated for skipped guests"
            }
          >
            <Typography sx={{ fontSize: '0.75rem', fontWeight: 500 }}>
              {Boolean(params.row?.guestContactNumber)
                ? params?.row?.guestContactNumber
                : '-'}
            </Typography>
          </Tooltip>
        ) : (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              width: '100%',
              backgroundColor: hasContactNumber ? '#f1f8e9' : '#fff3e0',
              borderRadius: '8px',
              padding: '4px 8px',
              border: hasContactNumber ? '1px solid #8bc34a' : '1px solid #ff9800'
            }}
            onClick={event => {
              event.stopPropagation();
              setCallApi(true);
              setSelectedTripRow(params.row);
              setValue('phone', params?.row?.guestContactNumber);
              setIsDialog('AddContact');
            }}
          >
            <Icon
              icon={hasContactNumber ? 'ph:phone-plus' : 'ph:arrows-clockwise'}
              style={{
                color: hasContactNumber ? '#4CAF50' : '#ff9800',
                cursor: 'pointer',
                fontSize: '20px',
                marginRight: '8px',
                userSelect: 'none'
              }}
              className={'activeIcon'}
              onClick={() => {
                setCallApi(true);
                setIsDialog('AddContact');
              }}
            />

            <Typography
              sx={{ fontSize: '0.75rem', fontWeight: '500', cursor: 'pointer' }}
            >
              {params.row?.guestContactNumber || 'Add contact'}
            </Typography>
          </Box>
        );
      }
    },

    {
      field: 'adultCount',
      headerName: 'Adult Count',
      minWidth: 100,
      maxWidth: 100,
      flex: 1,
      sortable: false,
      renderCell: (params: any) => (
        <Chip
          label={params.value}
          size='small'
          sx={{
            backgroundColor: '#eff2f4',
            color: '#3239ea',
            fontWeight: 'bold'
          }}
        />
      )
    },
    {
      field: 'childCount',
      headerName: 'Child Count',
      minWidth: 100,
      maxWidth: 100,
      flex: 1,
      sortable: false,
      renderCell: (params: any) => (
        <Chip
          label={params.value}
          size='small'
          sx={{
            backgroundColor: '#eff2f4',
            color: '#3239ea',
            fontWeight: 'bold'
          }}
        />
      )
    },
    {
      field: 'tripStatus',
      headerName: 'Status',
      minWidth: 120,
      maxWidth: 120,
      flex: 1,
      sortable: false,
      renderCell: ({ row }: any) => {
        const status: any = {
          Upcoming: 'Upcoming',
          Intransit: 'In-transit',
          Completed: 'Completed'
          // TotalJobs: 'Upcoming' + 'Completed' + 'In-transit'
        };
        return row?.tripStatus ? status[row?.tripStatus] : 'Upcoming';
      }
    },
    {
      field: 'source',
      headerName: 'From',
      minWidth: 250,
      flex: 1,
      sortable: false,
      renderCell: (params: any) => (
        <Tooltip enterDelay={200} leaveDelay={200} title={params.row.source} arrow>
          <Box
            sx={{
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              maxWidth: '100%',
              fontWeight: '500',
              color: '#424242',
              display: 'flex',
              justifyContent: 'flex-start',
              width: params.row.source ? '100%' : ''
            }}
          >
            {params.row.source ? params.row.source : '-'}
          </Box>
        </Tooltip>
      )
    },
    {
      field: 'destination',
      headerName: 'To',
      minWidth: 250,
      flex: 1,
      sortable: false,
      renderCell: (params: any) => (
        <Tooltip enterDelay={200} leaveDelay={200} title={params.row.destination} arrow>
          <Box
            sx={{
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              maxWidth: '100%',
              fontWeight: '500',
              color: '#424242',
              display: 'flex',
              justifyContent: 'flex-start',
              width: params.row.destination ? '100%' : ''
            }}
          >
            {params.row.destination ? params.row.destination : '-'}
          </Box>
        </Tooltip>
      )
    },
    {
      field: 'trfOrGuide',
      headerName: 'Transfer / Guide',
      minWidth: 270,
      maxWidth: 270,
      flex: 1,
      sortable: false,
      renderCell: (params: any) => (
        <Tooltip enterDelay={200} leaveDelay={200} title={params.row.trfOrGuide} arrow>
          <Box
            sx={{
              fontWeight: 'bold',
              backgroundColor: params.row.trfOrGuide ? '#aaaaaa96' : '',
              padding: params.row.trfOrGuide ? '4px 8px' : '',
              borderRadius: params.row.trfOrGuide ? '6px' : '',
              color: params.row.trfOrGuide ? '#7b1fa2' : ''
            }}
          >
            {params.row.trfOrGuide ? params.row.trfOrGuide : '-'}
          </Box>
        </Tooltip>
      )
    },
    {
      field: 'driverName',
      headerName: 'Driver Name',
      minWidth: 150,
      sortable: false,
      flex: 1,
      renderCell: (params: any) => (
        <span style={{ fontWeight: '500' }}>
          {params.value ? capitalizeFirstLetter(params.value) : '-'}
        </span>
      )
    },
    {
      field: 'vehicleNumber',
      headerName: 'Vehicle No.',
      minWidth: 150,
      flex: 1,
      sortable: false,
      renderCell: ({ value }: any) => (
        <Tooltip enterDelay={200} leaveDelay={200} title={value?.toUpperCase()}>
          <Chip
            label={value?.toLowerCase() === 'unassigned' ? value : value?.toUpperCase()}
            size='small'
            sx={{
              width: '120px',
              backgroundColor:
                value?.toLowerCase() === 'unassigned' ? '#ffebee' : '#e8f5e8',
              color: value?.toLowerCase() === 'unassigned' ? '#c62828' : '#2e7d32',
              fontWeight: 'bold',
              fontFamily: 'monospace'
            }}
          />
        </Tooltip>
      )
    },
    {
      field: 'driverContactNumber',
      headerName: 'Driver Contact No.',
      minWidth: 150,
      flex: 1,
      sortable: false,
      renderCell: (params: any) => (
        <span style={{ fontWeight: '500', color: '#424242' }}>{params.value}</span>
      )
    }
  ].map((item: any) => ({
    ...item,
    sortable: false,
    headerAlign: [
      'source',
      'destination',
      'agentName',
      'refNumber',
      'guestName',
      'tripStatus',
      'trfOrGuide',
      'driverName',
      'mode',
      'driverContactNumber'
    ]?.includes(item.field)
      ? 'left'
      : 'center',
    align: [
      'source',
      'destination',
      'agentName',
      'refNumber',
      'guestName',
      'tripStatus',
      'trfOrGuide',
      'driverName',
      'mode',
      'driverContactNumber'
    ]?.includes(item.field)
      ? 'left'
      : 'center'
  }));

  const adhocReqColumns: any[] = [
    ...(isAP
      ? [
          {
            field: 'actions',
            headerName: 'Action',
            type: 'actions',
            minWidth: 60,
            maxWidth: 60,
            flex: 1,
            sortable: false,
            // getActions: ({ row }: any) => {
            //   const adhocAccepted = row?.adhocAccepted;
            //   const isAdhoc =
            //     row?.isAdhoc && ['Upcoming', null]?.includes(row?.tripStatus);

            //   return isAdhoc
            //     ? APagent || APsubAgent
            //       ? [
            //           // <>
            //           <GridActionsCellItem
            //             icon={
            //               <Icon
            //                 icon='mdi:pencil'
            //                 height={18}
            //                 width={18}
            //                 color='#0d9488'
            //               />
            //             }
            //             label='Update'
            //             onClick={(e: any) => {
            //               e.stopPropagation();
            //               setSelectedTripRow(row);
            //               setIsDialog('adhoc');
            //               setCallApi(true);
            //             }}
            //             sx={{
            //               padding: '4px 8px',
            //               borderRadius: '4px',
            //               display: 'flex',
            //               alignItems: 'center',
            //               justifyContent: 'center',
            //               '&:hover': {
            //                 backgroundColor: '#f0fdfa'
            //               }
            //             }}
            //             showInMenu
            //           />,

            //           <GridActionsCellItem
            //             icon={
            //               <Icon
            //                 icon='mdi:delete'
            //                 height={18}
            //                 width={18}
            //                 color='#dc2626'
            //               />
            //             }
            //             label='Delete'
            //             onClick={(e: any) => {
            //               e.stopPropagation();
            //               setSelectedTripRow(row);
            //               setIsDialog('delete');
            //               setCallApi(true);
            //             }}
            //             sx={{
            //               padding: '4px 8px',
            //               borderRadius: '4px',
            //               display: 'flex',
            //               alignItems: 'center',
            //               justifyContent: 'center',
            //               '&:hover': {
            //                 backgroundColor: '#fef2f2' // light red hover
            //               }
            //             }}
            //             showInMenu
            //           />
            //           // </>
            //         ]
            //       : [
            //           <GridActionsCellItem
            //             icon={
            //               <Icon
            //                 icon='mdi:pencil'
            //                 height={18}
            //                 width={18}
            //                 color='#0d9488'
            //               />
            //             }
            //             label='Update'
            //             onClick={(e: any) => {
            //               e.stopPropagation();
            //               setSelectedTripRow(row);
            //               setIsDialog('adhoc');
            //               setCallApi(true);
            //             }}
            //             sx={{
            //               padding: '4px 8px',
            //               borderRadius: '4px',
            //               display: 'flex',
            //               alignItems: 'center',
            //               justifyContent: 'center',
            //               '&:hover': {
            //                 backgroundColor: '#f0fdfa'
            //               }
            //             }}
            //             showInMenu
            //           />
            //         ]
            //     : [
            //         <GridActionsCellItem
            //           sx={{ marginLeft: '10px' }}
            //           icon={
            //             <Tooltip title='Only upcoming ad-hoc bookings are editable'>
            //               <span>
            //                 <Icon
            //                   icon='ic:round-lock'
            //                   className='menu-icon update'
            //                   color='grey'
            //                   height='20'
            //                   width='20'
            //                 />
            //               </span>
            //             </Tooltip>
            //           }
            //           label='Not Editable'
            //           // onClick={(e: any) => e.stopPropagation()}
            //           // disabled
            //         />
            //       ];
            // }
            getActions: ({ row }: any) => {
              const adhocAccepted = row?.adhocAccepted;
              const isAdhoc =
                row?.isAdhoc && ['Upcoming', null]?.includes(row?.tripStatus);

              if (adhocAccepted) {
                return [
                  <GridActionsCellItem
                    sx={{ marginLeft: '10px' }}
                    icon={
                      <Tooltip title='This booking is already accepted'>
                        <span>
                          <Icon
                            icon='ic:round-lock'
                            className='menu-icon update'
                            color='grey'
                            height='20'
                            width='20'
                          />
                        </span>
                      </Tooltip>
                    }
                    label='Not Editable'
                  />
                ];
              }

              return isAdhoc
                ? APagent || APsubAgent
                  ? [
                      <GridActionsCellItem
                        icon={
                          <Icon
                            icon='mdi:pencil'
                            height={18}
                            width={18}
                            color='#0d9488'
                          />
                        }
                        label='Update'
                        onClick={(e: any) => {
                          e.stopPropagation();
                          setSelectedTripRow(row);
                          setIsDialog('adhoc');
                          setCallApi(true);
                        }}
                        sx={{
                          padding: '4px 8px',
                          borderRadius: '4px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          '&:hover': {
                            backgroundColor: '#f0fdfa'
                          }
                        }}
                        showInMenu
                      />,
                      <GridActionsCellItem
                        icon={
                          <Icon
                            icon='mdi:delete'
                            height={18}
                            width={18}
                            color='#dc2626'
                          />
                        }
                        label='Delete'
                        onClick={(e: any) => {
                          e.stopPropagation();
                          setSelectedTripRow(row);
                          setIsDialog('delete');
                          setCallApi(true);
                        }}
                        sx={{
                          padding: '4px 8px',
                          borderRadius: '4px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          '&:hover': {
                            backgroundColor: '#fef2f2'
                          }
                        }}
                        showInMenu
                      />
                    ]
                  : [
                      <GridActionsCellItem
                        icon={
                          <Icon
                            icon='mdi:pencil'
                            height={18}
                            width={18}
                            color='#0d9488'
                          />
                        }
                        label='Update'
                        onClick={(e: any) => {
                          e.stopPropagation();
                          setSelectedTripRow(row);
                          setIsDialog('adhoc');
                          setCallApi(true);
                        }}
                        sx={{
                          padding: '4px 8px',
                          borderRadius: '4px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          '&:hover': {
                            backgroundColor: '#f0fdfa'
                          }
                        }}
                        showInMenu
                      />
                    ]
                : [
                    <GridActionsCellItem
                      sx={{ marginLeft: '10px' }}
                      icon={
                        <Tooltip title='Only upcoming ad-hoc bookings are editable'>
                          <span>
                            <Icon
                              icon='ic:round-lock'
                              className='menu-icon update'
                              color='grey'
                              height='20'
                              width='20'
                            />
                          </span>
                        </Tooltip>
                      }
                      label='Not Editable'
                    />
                  ];
            }
          }
        ]
      : []),

    // {
    //   field: 'status',
    //   headerName: 'Status',
    //   minWidth: 100,
    //   maxWidth: 100,
    //   flex: 1,
    //   sortable: false,
    //   renderCell: ({ row }: any) => {
    //     const updateTime = row?.guestStatusChangeAt;
    //     return (
    //       <Tooltip
    //         enterDelay={200}
    //         leaveDelay={200}
    //         title={
    //           row?.isGuestArrived === 'Arrived'
    //             ? 'Onboarded'
    //             : row?.isGuestArrived === 'Not Arrived'
    //             ? 'No show'
    //             : row?.isGuestArrived === 'Skipped'
    //             ? 'Skipped'
    //             : 'Yet to board'
    //         }
    //       >
    //         <Box sx={{ display: 'flex', alignItems: 'center' }}>
    //           <Icon
    //             icon={
    //               row?.isGuestArrived === 'Arrived'
    //                 ? 'mdi:tick-circle-outline'
    //                 : row?.isGuestArrived === 'Not Arrived'
    //                 ? 'mingcute:close-circle-line'
    //                 : row?.isGuestArrived === 'Skipped'
    //                 ? 'mdi:skip-next-circle-outline'
    //                 : 'ic:sharp-pending-actions'
    //             }
    //             height={18}
    //             width={18}
    //             style={{ marginRight: '10px' }}
    //             color={
    //               row?.isGuestArrived === 'Arrived'
    //                 ? '#00b25c'
    //                 : row?.isGuestArrived === 'Not Arrived'
    //                 ? '#ff0004'
    //                 : row?.isGuestArrived === 'Skipped'
    //                 ? '#6c757d'
    //                 : 'orange'
    //             }
    //           />
    //           {updateTime === 0 ? '' : `${epochToTimeFormat(updateTime, timeZone)}`}
    //         </Box>
    //       </Tooltip>
    //     );
    //   }
    // },
    {
      field: 'time',
      headerName: 'Time',
      minWidth: 100,
      maxWidth: 100,
      flex: 1,
      sortable: false,
      renderCell: (params: any) => {
        let timeStr = params.value;

        if (!timeStr) return '';

        let [hours, minutes] = timeStr.split(':').map(Number);
        let period = hours >= 12 ? 'PM' : 'AM';

        hours = hours % 12 || 12;

        return (
          <Tooltip
            enterDelay={200}
            leaveDelay={200}
            title={`${hours.toString().padStart(2, '0')}:${minutes
              .toString()
              .padStart(2, '0')} ${period}`}
          >
            <Chip
              label={`${hours.toString().padStart(2, '0')}:${minutes
                .toString()
                .padStart(2, '0')} ${period}`}
              size='small'
              sx={{
                backgroundColor: '#e3f2fd',
                color: '#1976d2',
                fontWeight: 'bold',
                fontSize: '0.75rem'
              }}
            />
          </Tooltip>
        );
      }
    },
    {
      field: 'agentName',
      headerName: 'Agent',
      minWidth: 150,
      flex: 1,
      sortable: false,
      renderCell: ({ row }: any) => {
        return (
          <Box component={'span'} sx={{ fontSize: '12px' }}>
            {row?.agentName ? capitalizeFirstLetter(row?.agentName) : '-'}
          </Box>
        );
      }
    },
    {
      field: 'mode',
      headerName: 'Mode',
      minWidth: 70,
      maxWidth: 70,
      flex: 1,
      sortable: false,
      renderCell: ({ row }: any) => {
        return (
          <Box component={'span'} sx={{ fontSize: '12px' }}>
            {row?.mode ? row?.mode?.toUpperCase() : '-'}
          </Box>
        );
      }
    },
    {
      field: 'refNumber',
      headerName: 'Ref No.',
      minWidth: 150,
      flex: 1,
      sortable: false,
      renderCell: (params: any) => (
        <Tooltip enterDelay={200} leaveDelay={200} title={params.value || ''}>
          <span style={{ fontSize: '12px' }}>{params.value ? params.value : '-'}</span>
        </Tooltip>
      )
    },
    {
      field: 'guestName',
      headerName: 'Guest',
      minWidth: 150,
      flex: 1,
      sortable: false,
      renderCell: (params: any) => (
        <Tooltip enterDelay={200} leaveDelay={200} title={params.value || ''}>
          <Typography
            noWrap
            sx={{ width: params?.value ? '200px' : '', fontSize: '12px' }}
          >
            {params.value ? capitalizeFirstLetter(params.value) : '-'}
          </Typography>
        </Tooltip>
      )
    },
    {
      field: 'guestContactNumber',
      headerName: 'Guest Contact No.',
      minWidth: 200,
      flex: 1,
      sortable: false,
      renderCell: (params: any) => {
        if (params.row?.mode === 'RLR') {
          return <Typography sx={{ fontSize: '0.75rem', fontWeight: 500 }}>-</Typography>;
        } else {
          return (
            <Typography
              sx={{ fontSize: '0.75rem', fontWeight: '500', cursor: 'pointer' }}
            >
              {params.row?.guestContactNumber || '-'}
            </Typography>
          );
        }

        const hasContactNumber = params.row?.driverContactNumber === 'null';

        // return params?.row?.isGuestArrived === 'Skipped' ||
        //   params?.row?.tripStatus === 'Completed' ? (
        //   <Tooltip
        //     enterDelay={200}
        //     leaveDelay={200}
        //     title={
        //       params?.row?.tripStatus === 'Completed'
        //         ? "Contact number can't be updated for completed bookings"
        //         : "Contact number can't be updated for skipped guests"
        //     }
        //   >
        //     <Typography sx={{ fontSize: '0.75rem', fontWeight: 500 }}>
        //       {Boolean(params.row?.guestContactNumber)
        //         ? params?.row?.guestContactNumber
        //         : '-'}
        //     </Typography>
        //   </Tooltip>
        // ) : (
        //   <Box
        //     sx={{
        //       display: 'flex',
        //       alignItems: 'center',
        //       width: '100%',
        //       backgroundColor: hasContactNumber ? '#f1f8e9' : '#fff3e0',
        //       borderRadius: '8px',
        //       padding: '4px 8px',
        //       border: hasContactNumber ? '1px solid #8bc34a' : '1px solid #ff9800'
        //     }}
        //     onClick={event => {
        //       event.stopPropagation();
        //       setCallApi(true);
        //       setSelectedTripRow(params.row);
        //       setValue('phone', params?.row?.guestContactNumber);
        //       setIsDialog('AddContact');
        //     }}
        //   >
        //     <Icon
        //       icon={hasContactNumber ? 'ph:phone-plus' : 'ph:arrows-clockwise'}
        //       style={{
        //         color: hasContactNumber ? '#4CAF50' : '#ff9800',
        //         cursor: 'pointer',
        //         fontSize: '20px',
        //         marginRight: '8px',
        //         userSelect: 'none'
        //       }}
        //       className={'activeIcon'}
        //       onClick={() => {
        //         setCallApi(true);
        //         setIsDialog('AddContact');
        //       }}
        //     />

        //     <Typography
        //       sx={{ fontSize: '0.75rem', fontWeight: '500', cursor: 'pointer' }}
        //     >
        //       {params.row?.guestContactNumber || 'Add contact'}
        //     </Typography>
        //   </Box>
        // );
      }
    },

    {
      field: 'adultCount',
      headerName: 'Adult Count',
      minWidth: 100,
      maxWidth: 100,
      flex: 1,
      sortable: false,
      renderCell: (params: any) => (
        <Chip
          label={params.value}
          size='small'
          sx={{
            backgroundColor: '#eff2f4',
            color: '#3239ea',
            fontWeight: 'bold'
          }}
        />
      )
    },
    {
      field: 'childCount',
      headerName: 'Child Count',
      minWidth: 100,
      maxWidth: 100,
      flex: 1,
      sortable: false,
      renderCell: (params: any) => (
        <Chip
          label={params.value}
          size='small'
          sx={{
            backgroundColor: '#eff2f4',
            color: '#3239ea',
            fontWeight: 'bold'
          }}
        />
      )
    },
    // {
    //   field: 'tripStatus',
    //   headerName: 'Status',
    //   minWidth: 120,
    //   maxWidth: 120,
    //   flex: 1,
    //   sortable: false,
    //   renderCell: ({ row }: any) => {
    //     const status: any = {
    //       Upcoming: 'Upcoming',
    //       Intransit: 'In-transit',
    //       Completed: 'Completed'
    //       // TotalJobs: 'Upcoming' + 'Completed' + 'In-transit'
    //     };
    //     return row?.tripStatus ? status[row?.tripStatus] : 'Upcoming';
    //   }
    // },
    {
      field: 'source',
      headerName: 'From',
      minWidth: 250,
      flex: 1,
      sortable: false,
      renderCell: (params: any) => (
        <Tooltip enterDelay={200} leaveDelay={200} title={params.row.source} arrow>
          <Box
            sx={{
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              maxWidth: '100%',
              fontWeight: '500',
              color: '#424242',
              display: 'flex',
              justifyContent: 'flex-start',
              width: params.row.source ? '100%' : ''
            }}
          >
            {params.row.source ? params.row.source : '-'}
          </Box>
        </Tooltip>
      )
    },
    {
      field: 'destination',
      headerName: 'To',
      minWidth: 250,
      flex: 1,
      sortable: false,
      renderCell: (params: any) => (
        <Tooltip enterDelay={200} leaveDelay={200} title={params.row.destination} arrow>
          <Box
            sx={{
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              maxWidth: '100%',
              fontWeight: '500',
              color: '#424242',
              display: 'flex',
              justifyContent: 'flex-start',
              width: params.row.destination ? '100%' : ''
            }}
          >
            {params.row.destination ? params.row.destination : '-'}
          </Box>
        </Tooltip>
      )
    }
    // {
    //   field: 'trfOrGuide',
    //   headerName: 'Transfer / Guide',
    //   minWidth: 270,
    //   maxWidth: 270,
    //   flex: 1,
    //   sortable: false,
    //   renderCell: (params: any) => (
    //     <Tooltip enterDelay={200} leaveDelay={200} title={params.row.trfOrGuide} arrow>
    //       <Box
    //         sx={{
    //           fontWeight: 'bold',
    //           backgroundColor: params.row.trfOrGuide ? '#aaaaaa96' : '',
    //           padding: params.row.trfOrGuide ? '4px 8px' : '',
    //           borderRadius: params.row.trfOrGuide ? '6px' : '',
    //           color: params.row.trfOrGuide ? '#7b1fa2' : ''
    //         }}
    //       >
    //         {params.row.trfOrGuide ? params.row.trfOrGuide : '-'}
    //       </Box>
    //     </Tooltip>
    //   )
    // },
    // {
    //   field: 'driverName',
    //   headerName: 'Driver Name',
    //   minWidth: 150,
    //   sortable: false,
    //   flex: 1,
    //   renderCell: (params: any) => (
    //     <span style={{ fontWeight: '500' }}>
    //       {params.value ? capitalizeFirstLetter(params.value) : '-'}
    //     </span>
    //   )
    // },
    // {
    //   field: 'vehicleNumber',
    //   headerName: 'Vehicle No.',
    //   minWidth: 150,
    //   flex: 1,
    //   sortable: false,
    //   renderCell: ({ value }: any) => (
    //     <Tooltip enterDelay={200} leaveDelay={200} title={value?.toUpperCase()}>
    //       <Chip
    //         label={value?.toLowerCase() === 'unassigned' ? value : value?.toUpperCase()}
    //         size='small'
    //         sx={{
    //           width: '120px',
    //           backgroundColor:
    //             value?.toLowerCase() === 'unassigned' ? '#ffebee' : '#e8f5e8',
    //           color: value?.toLowerCase() === 'unassigned' ? '#c62828' : '#2e7d32',
    //           fontWeight: 'bold',
    //           fontFamily: 'monospace'
    //         }}
    //       />
    //     </Tooltip>
    //   )
    // },
    // {
    //   field: 'driverContactNumber',
    //   headerName: 'Driver Contact No.',
    //   minWidth: 150,
    //   flex: 1,
    //   sortable: false,
    //   renderCell: (params: any) => (
    //     <span style={{ fontWeight: '500', color: '#424242' }}>{params.value}</span>
    //   )
    // }
  ].map((item: any) => ({
    ...item,
    sortable: false,
    headerAlign: [
      'source',
      'destination',
      'agentName',
      'refNumber',
      'guestName',
      'tripStatus',
      'trfOrGuide',
      'driverName',
      'mode',
      'driverContactNumber'
    ]?.includes(item.field)
      ? 'left'
      : 'center',
    align: [
      'source',
      'destination',
      'agentName',
      'refNumber',
      'guestName',
      'tripStatus',
      'trfOrGuide',
      'driverName',
      'mode',
      'driverContactNumber'
    ]?.includes(item.field)
      ? 'left'
      : 'center'
  }));

  const isOverview = [
    groupView && (APoperator || APsuperAdmin),
    !groupView && !(APoperator || APsuperAdmin)
  ]?.some(item => item);

  const groupColumns: any = [
    {
      field: 'status',
      headerName: 'Status',
      minWidth: 100,
      width: 50,
      flex: 1,
      sortable: false,
      renderCell: ({ row }: any) => {
        return (
          <Tooltip
            enterDelay={200}
            leaveDelay={200}
            title={[null, 'Upcoming']?.includes(row?.status) ? 'Upcoming' : row?.status}
          >
            <Icon
              icon={
                row?.status === 'Completed'
                  ? 'mdi:tick-circle-outline'
                  : row?.status === 'Skipped'
                  ? 'mdi:skip-next-circle-outline'
                  : [null, 'Upcoming']?.includes(row?.status)
                  ? 'ic:sharp-pending-actions'
                  : 'bx:trip'
              }
              height={18}
              width={18}
              color={
                row?.status === 'Completed'
                  ? '#00b25c'
                  : row?.status === 'Skipped'
                  ? '#6c757d'
                  : [null, 'Upcoming']?.includes(row?.status)
                  ? 'orange'
                  : '#c7a107'
              }
            />
          </Tooltip>
        );
      }
    },
    {
      field: 'timeFrom',
      headerName: 'Time',
      flex: 1,
      minWidth: 50,
      renderCell: (params: any) => {
        let timeStr = params.value;

        if (!timeStr) return '';

        let [hours, minutes] = timeStr.split(':').map(Number);
        let period = hours >= 12 ? 'PM' : 'AM';

        hours = hours % 12 || 12;

        return (
          <Tooltip
            enterDelay={200}
            leaveDelay={200}
            title={`${hours.toString().padStart(2, '0')}:${minutes
              .toString()
              .padStart(2, '0')} ${period}`}
          >
            <Chip
              label={`${hours.toString().padStart(2, '0')}:${minutes
                .toString()
                .padStart(2, '0')} ${period}`}
              size='small'
              sx={{
                backgroundColor: '#e3f2fd',
                color: '#1976d2',
                fontWeight: 'bold',
                fontSize: '0.75rem'
              }}
            />
          </Tooltip>
        );
      }
    },
    {
      field: 'tourName',
      headerName: 'Tour Name / From-To',
      minWidth: 200,
      flex: 1,
      renderCell: ({ row }: any) => {
        return row?.tourName ? (
          <Tooltip
            enterDelay={200}
            leaveDelay={200}
            title={row?.tourName?.replace('->', '-')}
          >
            <Box
              sx={{
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                maxWidth: '100%',
                fontWeight: '500',
                color: '#424242'
              }}
            >
              {row?.tourName?.replace('->', '-')}
            </Box>
          </Tooltip>
        ) : (
          <Box>-</Box>
        );
      }
    },
    {
      field: 'mode',
      headerName: 'Mode',
      flex: 1,
      minWidth: 80,
      renderCell: ({ row }: any) => (
        <span style={{ fontWeight: '500' }}>
          {row.mode ? capitalizeFirstLetter(row.mode) : '-'}
        </span>
      )
    },
    {
      field: 'vehicleNumber',
      headerName: 'Vehicle No.',
      flex: 1,
      minWidth: 150,
      sortable: false,
      renderCell: ({ value, row }: any) => {
        const isNotRlR = row?.mode !== 'RLR' && ['Upcoming', null]?.includes(row?.status);

        return (
          <Tooltip
            enterDelay={200}
            leaveDelay={200}
            title={isNotRlR ? 'Click to change vehicle' : 'Not allowed'}
          >
            <Box
              onClick={isNotRlR ? () => handleOpenDialog(row) : undefined}
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                gap: 1,
                px: 1.8,
                py: 0.5,
                borderRadius: '20px',
                width: '120px',
                cursor: isNotRlR ? 'pointer' : 'not-allowed',
                fontWeight: 'bold',
                fontFamily: 'monospace',
                backgroundColor:
                  value?.toLowerCase() === 'unassigned' ? '#ffebee' : '#e8f5e8',
                color: value?.toLowerCase() === 'unassigned' ? '#c62828' : '#2e7d32',
                border: '1px solid',
                borderColor:
                  value?.toLowerCase() === 'unassigned' ? '#f44336' : '#66bb6a',
                boxShadow: '0 1px 4px rgba(0,0,0,0.1)',
                transition: 'all 0.2s ease-in-out',
                '&:hover': {
                  backgroundColor:
                    value?.toLowerCase() === 'unassigned' ? '#ffcdd2' : '#c8e6c9',
                  transform: isNotRlR ? 'scale(1.03)' : 'none'
                },
                pointerEvents: isNotRlR ? 'auto' : 'none',
                opacity: isNotRlR ? 1 : 0.5
              }}
            >
              <span style={{ flex: 1 }}>
                {value?.toLowerCase() === 'unassigned' ? value : value?.toUpperCase()}
              </span>
              {isNotRlR && <EditIcon sx={{ fontSize: 16 }} />}
            </Box>
          </Tooltip>
        );
      }
    },

    {
      field: 'driverContact',
      headerName: 'Driver Contact No.',
      flex: 1,
      minWidth: 250,
      renderCell: (params: any) => {
        const hasContactNumber = params.value == 'null';

        return (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              width: '75%',
              backgroundColor: hasContactNumber ? '#f1f8e9' : '#fff3e0',
              borderRadius: '8px',
              padding: '4px 8px',
              justifyContent: 'center',
              border: hasContactNumber ? '1px solid #8bc34a' : '1px solid #ff9800'
            }}
          >
            <Typography sx={{ fontSize: '0.75rem', fontWeight: '500' }}>
              {params.value || 'No contact'}
            </Typography>
          </Box>
        );
      }
    },
    {
      field: 'name',
      headerName: 'Driver Name',
      flex: 1,
      minWidth: 150,
      renderCell: (params: any) => (
        <span style={{ fontWeight: '500' }}>
          {params.value ? capitalizeFirstLetter(params.value) : '-'}
        </span>
      )
    },
    {
      field: 'tripsView',
      headerName: 'Jobs',
      flex: 1,
      minWidth: 150,
      renderCell: (params: any) => (
        <Box
          className='view-available'
          onClick={event => {
            event.stopPropagation();
            setCallApi(true);
            if (isOverview) {
              handleHotelsandGuestsView(params?.row);
            }
          }}
        >
          <Icon icon='fluent:guest-add-20-filled' className='view-available-icon' />
          <Typography className='view-available-text'>View</Typography>
        </Box>
      )
    }
  ]?.map((value: any) => ({
    ...value,
    headerAlign: ['tourName', 'name', 'mode'].includes(value.field) ? 'left' : 'center',
    align: ['tourName', 'name', 'mode'].includes(value.field) ? 'left' : 'center',
    sortable: false
  }));

  const handleGuestContactChange = Debounce(async (event: any, journey: any) => {
    if (!event) {
      handleGuestContactChange.cancel();
      setInvalidRows((prev: any) => {
        const updatedRows = prev?.map((item: any) => ({
          ...item,
          color: item?.journeyID === journey ? '' : item?.color,
          contactNumber: item?.journeyID === journey ? '' : item?.contactNumber,
          isError: item?.journeyID === journey ? false : item?.isError
        }));
        return updatedRows;
      });
    }

    if (event) {
      let action1 = await dispatch(contactNumberValidation(event));

      if (action1?.payload) {
        setInvalidRows((prev: any) => {
          const updatedRows = prev?.map((item: any) => ({
            ...item,
            color:
              item?.journeyID === journey
                ? action1.payload?.status !== 200
                  ? '#ff07078c'
                  : ''
                : item?.color,
            contactNumber: item?.journeyID === journey ? event : item?.contactNumber,
            isError:
              item?.journeyID === journey && event
                ? action1?.payload?.status !== 200
                : item?.isError
          }));

          return updatedRows;
        });
      }
    }
  }, 500);

  const invalidColumns: any[] = [
    {
      field: 'time',
      headerName: 'Time',
      minWidth: 100,
      flex: 1,
      sortable: false,
      renderCell: (params: any) => {
        let timeStr = params.value;

        if (!timeStr) return '';

        let [hours, minutes] = timeStr.split(':').map(Number);
        let period = hours >= 12 ? 'PM' : 'AM';

        hours = hours % 12 || 12;

        return `${hours}:${minutes.toString().padStart(2, '0')} ${period}`;
      }
    },

    { field: 'agentName', headerName: 'Agent', minWidth: 150, flex: 1, sortable: false },
    { field: 'mode', headerName: 'Mode', minWidth: 100, flex: 1, sortable: false },
    {
      field: 'refNumber',
      headerName: 'Ref No.',
      minWidth: 150,
      flex: 1,
      sortable: false,
      renderCell: (params: any) => (
        <Tooltip enterDelay={200} leaveDelay={200} title={params.value || ''}>
          <span>{params.value}</span>
        </Tooltip>
      )
    },
    {
      field: 'guestName',
      headerName: 'Guest',
      minWidth: 220,
      flex: 1,
      sortable: false,
      renderCell: (params: any) => (
        <Tooltip enterDelay={200} leaveDelay={200} title={params.value || ''}>
          <span>{params.value}</span>
        </Tooltip>
      )
    },
    {
      field: 'guestContactNumber',
      headerName: 'Guest Contact Number',
      minWidth: 250,
      flex: 1,
      renderCell: (params: any) => {
        const row: any = params.row as { journeyId: string };
        const journyId = row.journeyID;

        return (
          <Box
            sx={{
              width: '100%',
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              overflow: 'hidden',
              px: 1
            }}
          >
            <Controller
              name='phone'
              control={phoneControl}
              defaultValue={''}
              rules={{ required: true }}
              render={({ field }: any) => (
                <PhoneNoTextField
                  setValue={settingValue}
                  name='phone'
                  isOptional={true}
                  style='share'
                  margin={'2px'}
                  onChange={(e: any) => {
                    handleGuestContactChange(e, journyId);
                  }}
                />
              )}
            />
          </Box>
        );
      }
    },

    {
      field: 'source',
      headerName: 'From',
      minWidth: 250,
      flex: 1,
      sortable: false,
      renderCell: (params: any) => (
        <Tooltip enterDelay={200} leaveDelay={200} title={params.row.source} arrow>
          <Box
            sx={{
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              maxWidth: '100%'
            }}
          >
            {params.row.source}
          </Box>
        </Tooltip>
      )
    },
    {
      field: 'destination',
      headerName: 'To',
      minWidth: 250,
      flex: 1,
      sortable: false,
      renderCell: (params: any) => (
        <Tooltip enterDelay={200} leaveDelay={200} title={params.row.destination} arrow>
          <Box
            sx={{
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              maxWidth: '100%'
            }}
          >
            {params.row.destination}
          </Box>
        </Tooltip>
      )
    },

    {
      field: 'vehicleNumber',
      headerName: 'Vehicle No',
      minWidth: 100,
      flex: 1,
      sortable: false,
      renderCell: ({ value }: any) =>
        value?.toLowerCase() === 'unassigned' ? value : value?.toUpperCase()
    }
  ].map((item: any) => ({ ...item, sortable: false }));

  const handleClose = () => {
    clearErrors('');
    dispatch(clearWhatsapp());
    setCallApi(false);
    setIsDialog('');
    setValue('phone', '');
    restToggle();
    setSendWhatsApp(false);
  };

  const currentDatas = {
    data: isOverview ? groupData : rows,
    isLoading: isOverview ? groupStatusLoading : isLoading,
    count: isOverview ? groupCount : count,
    statusCount: isOverview ? groupStatusCount : statusCount,
    columns: isOverview ? groupColumns : columns
  };

  const handleSendWhatsapp = async () => {
    const payload = {
      autoplannerId: scheduleDate
    };
    const action = await dispatch(sendwhatsappAction(payload));

    if (!(action?.payload?.data?.data?.length > 0)) {
      setIsDialog('');
    }

    // setIsDialog('');
  };

  const handleSkip = async () => {
    const payload = {
      autoplannerId: scheduleDate,
      skippingPhoneNumber: true
    };
    await dispatch(sendwhatsappAction(payload));
    dispatch(clearWhatsapp());
    setIsDialog('');
  };

  const handleUpdateContact = async () => {
    const filteredRows = invalidRows?.filter((item: any) => item?.contactNumber);

    const payloadData = filteredRows?.map((item: any) => ({
      autoplannerID,
      guestContactNumber: item?.contactNumber,
      journyId: item?.journeyID
    }));
    if (payloadData?.length > 0) {
      await dispatch(guestContactUpdateAction(payloadData));
    }
    setGuestContactList([]);
    const payload = {
      autoplannerId: scheduleDate
    };
    const action = await dispatch(sendwhatsappAction(payload));

    if (
      action?.payload?.status == 200 &&
      action.payload.data?.message === 'All messages sent successfully'
    ) {
      setIsDialog('');
    }
  };

  const handleDeleteDriver = async () => {
    const payload = {
      selectedRow: selectedTripRow,
      pageDetails: { PageNo, PageSize },
      APagent: APagent,
      APsubAgent: APsubAgent
    };
    const res = await dispatch(autoPlannerDeleteAction(payload));
    if (res?.meta?.requestStatus === 'fulfilled') {
      setIsDialog('');
      // await dispatch(getDriver({ ...payload, pageNo, pageSize }));
      const res: any = await dispatch(
        GetGrpBookings({
          mode: 'ALL',
          pageNo: 1,
          pageSize: 20,
          autoplannerID: autoplannerID,
          isAdhoc: true
        })
      );
      setBadgeCount(res?.payload?.data?.count ?? 0);
    }
  };

  useEffect(() => {
    return () => {
      dispatch(clearContactError());
    };
  }, []);

  useEffect(() => {
    return () => {
      dispatch(clearWhatsapp());
    };
  }, []);

  const handleInvalidClose = () => {
    dispatch(clearWhatsapp());
    setIsDialog('');
    // const payload = {
    //   ...tripPayload,
    //   ...filterPayload,
    //   PageNo: 1,
    //   PageSize: PageSize,
    //   autoplannerID: scheduleDate,
    //   tripMode: 'ALL',
    //   agentName: agent,
    //   guestName: guest,
    //   tourName: tour,
    //   vehicleNumber: vehicle
    // };
    // dispatch(getExcelAction(payload));
  };

  const handlePaginationModelChange = async (newPaginationModel: any) => {
    setRefreshLoader(true);

    const { pageSize: newPageSize, page: newPageNo } = newPaginationModel;
    setPageSize(newPageSize);
    setPageNo(newPageNo + 1);
    const newPage = newPageNo + 1;
    const payload = {
      PageNo: newPage,
      PageSize: newPageSize,
      autoplannerID: scheduleDate,
      tripMode: 'ALL',
      searchFor: searchEvent ? searchEvent : ''
    };

    if (isOverview) {
      await dispatch(getTodayTours(payload));
    } else {
      await dispatch(getExcelAction(payload));
    }
    setRefreshLoader(false);
  };

  const handlePaginationAdhocReq = async (newPaginationModel: any) => {
    setRefreshLoader(true);

    const { pageSize: newPageSize, page: newPageNo } = newPaginationModel;
    setPageSize(newPageSize);
    setPageNo(newPageNo + 1);

    const payload = {
      mode: 'ALL',
      pageNo: newPageNo + 1,
      pageSize: newPageSize,
      autoplannerID: autoplannerID,
      isAdhoc: true
    };

    try {
      await dispatch(GetGrpBookings(payload));
    } finally {
      setRefreshLoader(false);
    }
  };

  const handleFilterChange = useCallback(
    debounce(async (event: string) => {
      const payload = {
        PageNo: 1,
        PageSize: PageSize,
        autoplannerID: scheduleDate,
        tripMode: 'ALL',
        searchFor: event
      };
      setSearchEvent(event);
      setFilter(event);
      setPageNo(1);
      if (isOverview) {
        await dispatch(getTodayTours(payload));
      } else {
        await dispatch(getExcelAction(payload));
      }
    }),
    [PageNo, PageSize, scheduleDate, isOverview]
  );

  const ChipSkeleton = ({ key }: { key: string }) => {
    return (
      <Skeleton
        key={key}
        variant='rectangular'
        width={80}
        height={25}
        sx={{ borderRadius: 5, backgroundColor: '#ccc4c4' }}
      />
    );
  };

  // Get current date for display
  const getCurrentDate = () => {
    const today = new Date();
    return today.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      weekday: 'long',
      timeZone: timeZone
    });
  };

  //function to get today trips
  const handleTodayTrips = async () => {
    if (isOverview) {
      await dispatch(
        getTodayTours({
          PageNo: PageNo,
          PageSize: PageSize,
          autoplannerID: scheduleDate
          // searchFor: filter
        })
      );
    } else {
      await dispatch(
        getExcelAction({
          PageNo: PageNo,
          PageSize: PageSize,
          autoplannerID: scheduleDate,
          tripMode: 'ALL'
          // searchFor: filter
        })
      );
    }
  };

  //function to handle group view
  const handleGroupView = async (e: any) => {
    dispatch(clearTodayTour());
    dispatch(clearExcelView());
    setSearchEvent('');
    setFilter('');
    setValue('search', '');
    setGroupView(e.target.checked);
    setPageNo(1);
    setPageSize(20);
    if (!isOverview) {
      await dispatch(
        getTodayTours({
          PageNo: 1,
          PageSize: 20,
          autoplannerID: scheduleDate,
          searchFor: '',
          tripMode: 'ALL'
        })
      );
    } else {
      await dispatch(
        getExcelAction({
          PageNo: 1,
          PageSize: 20,
          autoplannerID: scheduleDate,
          searchFor: '',
          tripMode: 'ALL'
        })
      );
    }
    setPageNo(1);
    setPageSize(20);
  };

  //function to handle detailed view
  const handleHotelsandGuestsView = (row: any) => {
    setHotelGuestView(row);
  };

  const handleValidatephone = useCallback(
    debounce((event: any) => {
      dispatch(contactNumberValidation(event));
    }),
    [dispatch]
  );

  const onChangeNumberSubmit = async (params: any) => {
    const AddContactPayload = [
      {
        autoplannerID,
        guestContactNumber: params.phone,
        journyId: selectedTripRow?.journeyId
      }
    ];

    const ExcelPayload = {
      PageNo: PageNo,
      PageSize: PageSize,
      autoplannerID: scheduleDate,
      tripMode: 'ALL',
      searchFor: searchEvent ? searchEvent : ''
    };

    const action = await dispatch(guestContactUpdateAction(AddContactPayload));

    const payloads = {
      autoplannerId: scheduleDate,
      journeyId: selectedTripRow?.journeyId
    };
    if (sendWhatsApp) {
      await dispatch(sendwhatsappAction(payloads));
    }
    restToggle();
    handleClose();
    dispatch(getExcelAction(ExcelPayload));

    setSendWhatsApp(false);
  };

  const status = [
    'Upcoming',
    'Completed',
    'In-transit',
    'Skipped',

    'Yet to onboard',
    'Onboarded',
    'No show',
    'Skipped'
  ];

  useEffect(() => {
    if (!callApi && !currentDatas.isLoading && !isViewAdhoc) {
      if (PageNo === 1) {
        const interval = setInterval(async () => {
          const payload: any = {
            PageNo: PageNo,
            PageSize: PageSize,
            autoplannerID: scheduleDate
          };
          if (filter) {
            payload.searchFor = filter;
          }
          if (isOverview) {
            dispatch(getTodayTours(payload));
          } else {
            payload.tripMode = 'ALL';
            dispatch(getExcelAction(payload));
          }
          const res: any = await dispatch(
            GetGrpBookings({
              mode: 'ALL',
              pageNo: 1,
              pageSize: 20,
              autoplannerID: autoplannerID,
              isAdhoc: true
            })
          );
          setBadgeCount(res?.payload?.data?.count ?? 0);
        }, 10000);
        return () => clearInterval(interval);
      }
    }
  }, [
    PageNo,
    PageSize,
    scheduleDate,
    filter,
    isOverview,
    callApi,
    currentDatas.isLoading,
    isViewAdhoc
  ]);

  useLayoutEffect(() => {
    if (data?.length === 0) {
      setRows([]);
    }

    if (data?.length > 0) {
      const getExcel = data?.map((item: any, index: number) => ({
        ...item,
        id: index + 1,
        driver: item.driverName + ' - ' + item.driverContactNumber,
        totalCount: item?.adultCount + item?.childCount,
        color: ['Not Arrived']?.includes(item?.isGuestArrived)
          ? '#ffe0db'
          : ['Arrived']?.includes(item?.isGuestArrived)
          ? '#d6ffce'
          : item?.isGuestArrived === 'Skipped'
          ? '#D9D3D0'
          : '#fff',
        trfOrGuide:
          item.transferInstance !== null
            ? `TRF BY ${
                item.transferInstance?.driverName
              } ${item.transferInstance?.vehicleNumber?.toUpperCase()} ${
                item?.transferInstance.contactNumber
              }`
            : item.guideName
            ? `GUIDE ${item.guideName} ${item.guideContactNumber}`
            : ''
      }));

      setRows(getExcel);
      setRowCount(count);
    } else if (!isLoading) {
      setRows([]);
    }
  }, [data, isLoading]);

  const handleValidate = useCallback(
    debounce(async (event: any, field: any) => {
      const res: any = await dispatch(contactNumberValidation(event));
      setValidationErrorsMake((prev: any) => ({
        ...prev,
        [field]: res?.payload?.status !== 200 ? res?.payload : 'no-error'
      }));
    }),
    [dispatch]
  );

  const getStatusColor = (status: string) => {
    const normalized = status?.toLowerCase();

    if (['upcoming', 'yet to onboard'].includes(normalized)) {
      return 'orange';
    }
    if (['completed', 'onboarded'].includes(normalized)) {
      return '#00b25c';
    }
    if (['in-transit'].includes(normalized)) {
      return '#c7a107';
    }
    if (['no show'].includes(normalized)) {
      return 'rgb(255, 0, 4)';
    }
    if (['skipped', 'trip skipped'].includes(normalized)) {
      return '#6c757d';
    }

    return '#c7a107';
  };
  useEffect(() => {
    if (validationErrors?.driverNumber) {
      trigger('driverNumber');
    }
  }, [validationErrors]);

  useEffect(() => {
    if (profileData.timezone !== '' && zone) {
      setTimeZone(profileData.timezone);
      if (profileData?.timezone) setZone(false);
    }
  }, [profileData, zone]);

  useEffect(() => {
    if (timeZone !== 'UTC') {
      const epochTime = getTodayEpoch(timeZone);
      setScheduleDate(epochTime);
      // setScheduleDate(1753718400);

      if (APoperator || APsuperAdmin) {
        dispatch(
          getTodayTours({
            PageNo: 1,
            PageSize: 20,
            autoplannerID: epochTime,
            searchFor: '',
            tripMode: 'ALL'
          })
        );
      } else {
        dispatch(
          getExcelAction({
            PageNo: 1,
            PageSize: 20,
            autoplannerID: epochTime,
            tripMode: 'ALL',
            searchFor: ''
          })
        );
      }
      // dispatch(
      //   getExcelAction({
      //     PageNo: 1,
      //     PageSize: 20,
      //     autoplannerID: epochTime,
      //     tripMode: 'ALL',
      //     searchFor: ''
      //   })
      // );
    }
  }, [timeZone, APsuperAdmin, APoperator, groupView]);

  useEffect(() => {
    if (validationErrors?.phone) {
      phoneTrigger('phone');
    }
  }, [validationErrors?.phone]);

  useEffect(() => {
    if (sendwhatsapp?.data?.data?.length === 0) {
      setRows([]);
    }

    if (sendwhatsapp?.data?.data?.length > 0) {
      const invalidContact = sendwhatsapp?.data?.data?.map(
        (item: any, index: number) => ({
          ...item,
          id: index + 1,
          isError: false,
          contactNumber: '',
          color: ''
        })
      );

      setInvalidRows(invalidContact);
    } else {
      setInvalidRows([]);
    }
  }, [sendwhatsapp?.data?.data]);

  useEffect(() => {
    if (sendwhatsapp?.data?.count > 0) {
      setIsDialog('Nocontact');
    }
  }, [sendwhatsapp]);

  useEffect(() => {
    dispatch(
      GetGrpBookings({
        mode: 'ALL',
        pageNo: PageNo,
        pageSize: PageSize,
        autoplannerID: autoplannerID,
        isAdhoc: true
      })
    );
  }, [scheduleDate]);

  useEffect(() => {
    setBadgeCount(ViewAdhocReqData?.data?.count ?? 0);
  }, [ViewAdhocReqData?.data?.count]);

  useEffect(() => {
    const abortController = createAbort().abortCall;
    // dispatch(getMyProfileAction(abortController?.signal));
    dispatch(autoPlannerAgentAction(abortController?.signal));
    return () => {
      dispatch(clearTodayTour());
      dispatch(clearExcelView());
      abortController?.abort();
    };
  }, []);

  return (
    <>
      {!isViewAdhoc ? (
        <Box
          sx={{
            padding: 3
          }}
        >
          {!hotelGuestView && (
            <Paper
              elevation={0}
              sx={{
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                borderRadius: 2,
                p: { xs: 1.5, sm: 1.5 },
                mb: 1,
                color: 'white',
                position: 'relative',
                overflow: 'hidden'
              }}
            >
              <Box
              // sx={{
              //   position: 'absolute',
              //   top: -10,
              //   right: -10,
              //   width: 60,
              //   height: 60,
              //   background: 'rgba(255, 255, 255, 0.15)',
              //   borderRadius: '50%'
              // }}
              />
              <Box sx={{ position: 'relative', zIndex: 1 }}>
                <Grid container spacing={0.5}>
                  {/* Left Section */}
                  <Grid item xs={12} sm={12} md={4}>
                    <Box
                      sx={{
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        gap: 1
                      }}
                    >
                      <Typography
                        variant='h4'
                        sx={{
                          fontWeight: 'bold',
                          marginBottom: 0.5,
                          background: 'linear-gradient(45deg, #ffffff, #f0f8ff)',
                          backgroundClip: 'text',
                          WebkitBackgroundClip: 'text',
                          WebkitTextFillColor: 'transparent',
                          display: 'flex',
                          alignItems: 'center',
                          fontSize: { xs: '1.0rem', md: '1.5rem' }
                        }}
                      >
                        <Icon
                          icon='tdesign:vehicle-filled'
                          width='24'
                          height='24'
                          style={{ marginRight: '10px' }}
                        />
                        {/* Today's Jobs */}
                        Live Dashboard{' '}
                      </Typography>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                        <Icon
                          icon='lets-icons:date-fill'
                          width='20'
                          height='20'
                          style={{ color: '#dce5ff' }}
                        />
                        <Typography
                          variant='body2'
                          sx={{
                            opacity: 0.9,
                            fontWeight: 300,
                            fontSize: '0.9rem'
                          }}
                        >
                          {getCurrentDate()}
                        </Typography>
                      </Box>
                    </Box>
                  </Grid>

                  {isOverview && (
                    <>
                      <Grid item xs={12} sm={12} md={3.8} lg={3.9}>
                        <Box>
                          <Typography
                            sx={{
                              fontSize: '12px',
                              fontWeight: 'bold',
                              display: 'flex',
                              justifyContent: 'center',
                              marginBottom: '6px'
                            }}
                          >
                            Jobs -{' '}
                            {(currentDatas.statusCount['Upcoming'] ?? 0) +
                              (currentDatas.statusCount['In-transit'] ?? 0) +
                              (currentDatas.statusCount['Completed'] ?? 0) +
                              (currentDatas.statusCount['Trip Skipped'] ?? 0)}
                          </Typography>
                          <Grid
                            container
                            spacing={0.1}
                            sx={{
                              flexDirection: { xs: 'row', lg: 'row' },
                              flexWrap: { xs: 'wrap', lg: 'nowrap' },
                              gap: { lg: 1, xs: 0 }
                            }}
                          >
                            {status
                              ?.filter((_, index) => index < 4)
                              ?.map((item: any) => {
                                const count =
                                  item === 'Total'
                                    ? (currentDatas.statusCount['Upcoming'] ?? 0) +
                                      (currentDatas.statusCount['In-transit'] ?? 0) +
                                      (currentDatas.statusCount['Completed'] ?? 0) +
                                      (currentDatas.statusCount['Trip Skipped'] ?? 0)
                                    : currentDatas.statusCount[
                                        item === 'Skipped' ? 'Trip Skipped' : item
                                      ] ?? 0;

                                return (
                                  <Grid item xs={6} sm={3} md={6} key={item}>
                                    <Chip
                                      size='small'
                                      label={`${item} - ${count}`}
                                      sx={{
                                        width: '100%',
                                        justifyContent: 'center',
                                        border: `1px solid ${getStatusColor(item)}`,
                                        backgroundColor: '#fff',
                                        color: getStatusColor(item),
                                        fontWeight: 600,
                                        fontSize: '0.7rem',
                                        borderRadius: '8px',
                                        boxShadow: '0 1px 2px rgba(0,0,0,0.06)',
                                        transition: 'all 0.2s ease'
                                      }}
                                    />
                                  </Grid>
                                );
                              })}
                          </Grid>
                        </Box>
                      </Grid>

                      <Grid
                        item
                        xs={12}
                        lg={0.15}
                        md={0.1}
                        sx={{
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center'
                        }}
                      >
                        <Divider
                          flexItem
                          orientation={isMdUp ? 'vertical' : 'horizontal'}
                          sx={{
                            backgroundColor: 'rgba(255, 255, 255, 0.5)',
                            borderRadius: 1,
                            // height: isMdUp ? '60% !important' : '1px !important',
                            // width: isMdUp ? '1px !important' : '60% !important'
                            height: isMdUp ? '100%' : '1px',
                            width: isMdUp ? '1px' : '100%'
                          }}
                        />
                      </Grid>
                    </>
                  )}

                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={!isOverview ? 8 : 3.9}
                    lg={3.9}
                    sx={{
                      ml: !isOverview ? 'auto' : 0
                      // display: 'flex'
                    }}
                  >
                    <Box>
                      <Typography
                        sx={{
                          fontSize: '12px',
                          fontWeight: 'bold',
                          display: 'flex',
                          justifyContent: 'center',
                          marginBottom: '6px'
                        }}
                      >
                        Bookings - {currentDatas.statusCount['Total'] ?? 0}
                      </Typography>
                      <Grid
                        container
                        spacing={0.1}
                        sx={{
                          flexDirection: { xs: 'row', lg: 'row' },
                          flexWrap: { xs: 'wrap', lg: 'nowrap' },
                          gap: { lg: 0.5, xs: 0 }
                        }}
                      >
                        {status
                          ?.filter((_, index) => index > 3)
                          ?.map((item: any) => (
                            <Grid
                              item
                              xs={6}
                              sm={3}
                              md={!isOverview ? 3 : 6}
                              lg={6}
                              key={item}
                            >
                              <Chip
                                size='small'
                                label={`${
                                  item === 'Yet to onboard' ? 'Yet to board' : item
                                } - ${currentDatas.statusCount[item] ?? 0}`}
                                sx={{
                                  width: '100%',
                                  justifyContent: 'center',
                                  border: `1px solid ${getStatusColor(item)}`,
                                  backgroundColor: '#fff',
                                  color: getStatusColor(item),
                                  fontWeight: 600,
                                  fontSize: '0.7rem',
                                  borderRadius: '8px',
                                  boxShadow: '0 1px 2px rgba(0,0,0,0.06)',
                                  transition: 'all 0.2s ease'
                                }}
                              />
                            </Grid>
                          ))}
                      </Grid>
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            </Paper>
          )}
          {!hotelGuestView && (
            <>
              {(APoperator || APsuperAdmin) && (
                <Box
                  sx={{
                    float: { lg: 'right', xs: 'left', sm: 'right', md: 'right' },
                    display: 'flex',
                    alignItems: 'center',
                    gap: 2
                  }}
                >
                  <Typography>Bookings</Typography>
                  <AntSwitch
                    inputProps={{ 'aria-label': 'ant design' }}
                    className='ant-switch'
                    checked={groupView}
                    onChange={(e: any) => {
                      handleGroupView(e);
                    }}
                  />
                  <Typography>Jobs</Typography>
                </Box>
              )}
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: {
                    lg: 'flex-end',
                    sm: 'flex-end',
                    md: 'flex-end'
                  },
                  flexDirection: { xs: 'column', lg: 'row', sm: 'row', md: 'row' },
                  alignItems: 'center',
                  width: '100%'
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    // justifyContent: {
                    //   lg: 'flex-end',
                    //   sm: 'flex-end',
                    //   md: 'flex-end'
                    // },
                    flexDirection: { xs: 'column', lg: 'row', sm: 'row', md: 'row' },
                    alignItems: 'center',
                    width: '100%',
                    gap: '20px'
                  }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                    {/* <Box
                  sx={{
                    background: 'linear-gradient(135deg, #648DB3  0%, #5459AC 100%)',
                    padding: '10px',
                    display: 'flex',
                    gap: '1rem',
                    borderRadius: '10px',
                    alignItems: 'center',
                    position: 'relative'
                  }}
                  onClick={handleTodayTrips}
                >
                  <Box>
                    <Typography color={'#fff'} fontSize={'1rem'} fontWeight={600}>
                      Refresh
                    </Typography>
                  </Box>
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <Icon
                      icon={'ph:arrows-clockwise'}
                      style={{
                        color: '#ffffff',
                        cursor: 'pointer',
                        fontSize: '20px',
                        userSelect: 'none'
                      }}
                      className={`activerIcon ${refresh ? 'refresh' : ''}`}
                    />
                  </Box>
                </Box> */}

                    <>
                      {isShare && currentDatas?.data?.length > 0 ? (
                        <Box
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 1,
                            marginTop: 1,
                            position: { xs: 'relative' }
                          }}
                        >
                          <Tooltip enterDelay={200} leaveDelay={200} title={'Share Trip'}>
                            <Icon
                              icon='ic:sharp-whatsapp'
                              width='35'
                              height='35'
                              onClick={() => {
                                setIsDialog('whatsapp');
                                setCallApi(true);
                              }}
                              style={{
                                backgroundColor: '#25D366',
                                color: 'white',
                                borderRadius: '6px',
                                cursor: 'pointer',
                                padding: '6px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                              }}
                            />
                          </Tooltip>

                          {isAP && (
                            <Tooltip enterDelay={200} leaveDelay={200} title='Add Ad-hoc'>
                              <Icon
                                icon='material-symbols:post-add-rounded'
                                width='35'
                                height='35'
                                onClick={() => {
                                  setIsDialog('adhoc');
                                  setCallApi(true);
                                }}
                                style={{
                                  backgroundColor: '#0d9488',
                                  color: '#fff',
                                  borderRadius: '6px',
                                  cursor: 'pointer',
                                  padding: '6px',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center'
                                }}
                              />
                            </Tooltip>
                          )}

                          {isAP && badgeCount > 0 && (
                            <Tooltip
                              title='View Ad-hoc Requests'
                              enterDelay={200}
                              leaveDelay={200}
                            >
                              <Badge
                                badgeContent={badgeCount}
                                color='primary'
                                anchorOrigin={{
                                  vertical: 'top',
                                  horizontal: 'right'
                                }}
                              >
                                <Box
                                  onClick={() => {
                                    setIsViewAdhoc(true);
                                    setCallApi(true);
                                  }}
                                  sx={{
                                    width: 35,
                                    height: 35,
                                    borderRadius: '6px',
                                    cursor: 'pointer',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    color: '#fff',
                                    background:
                                      'linear-gradient(135deg, #0d9488, #14b8a6)',
                                    boxShadow: '0 3px 8px rgba(0,0,0,0.2)',
                                    '&:active': { transform: 'scale(0.95)' }
                                  }}
                                >
                                  <AssignmentTurnedInOutlinedIcon sx={{ fontSize: 22 }} />
                                </Box>
                              </Badge>
                            </Tooltip>
                          )}
                        </Box>
                      ) : (
                        <>
                          {currentDatas?.data?.length > 0 && (
                            <Button
                              variant='contained'
                              className='whatsapp'
                              startIcon={<WhatsAppIcon />}
                              sx={{
                                backgroundColor: '#25D366',
                                color: 'white',
                                textTransform: 'none',
                                padding: '8px 20px',
                                borderRadius: '8px',
                                boxShadow: '0 1px 3px rgba(0,0,0,0.2)',
                                '&:hover': { backgroundColor: '#1EBE57' }
                              }}
                              onClick={() => {
                                setIsDialog('whatsapp');
                                setCallApi(true);
                              }}
                            >
                              Share Trip
                            </Button>
                          )}

                          {(isAP || APsubAgent) && (
                            <Button
                              variant='contained'
                              startIcon={<PostAddIcon />}
                              sx={{
                                backgroundColor: '#0d9488',
                                color: 'white',
                                textTransform: 'none',
                                padding: '8px 20px',
                                borderRadius: '8px',
                                boxShadow: '0 1px 3px rgba(0,0,0,0.2)',
                                '&:hover': { backgroundColor: '#0b7c73' }
                              }}
                              onClick={() => {
                                setIsDialog('adhoc');
                                setCallApi(true);
                                setSelectedTripRow(null);
                              }}
                            >
                              Add Ad-hoc
                            </Button>
                          )}
                          {isAP && badgeCount > 0 && (
                            <Tooltip
                              title='View Ad-hoc Requests'
                              enterDelay={200}
                              leaveDelay={200}
                            >
                              <Badge
                                badgeContent={badgeCount}
                                color='primary'
                                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                              >
                                <Box
                                  onClick={() => {
                                    setIsViewAdhoc(true);
                                    setCallApi(true);
                                  }}
                                  sx={{
                                    width: 38,
                                    height: 38,
                                    borderRadius: 2,
                                    cursor: 'pointer',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    color: '#fff',
                                    background:
                                      'linear-gradient(135deg, #0d9488, #14b8a6)',
                                    boxShadow: '0 3px 8px rgba(0,0,0,0.2)',
                                    // transition: 'transform 0.25s, box-shadow 0.25s',
                                    '&:hover': {
                                      // transform: 'scale(1.1)',
                                      boxShadow: '0 5px 12px rgba(0,0,0,0.25)'
                                    },
                                    '&:active': { transform: 'scale(0.95)' }
                                  }}
                                >
                                  <AssignmentTurnedInOutlinedIcon sx={{ fontSize: 22 }} />
                                </Box>
                              </Badge>
                            </Tooltip>
                          )}
                        </>
                      )}
                    </>
                  </Box>
                  {/* <Box
              sx={{
                background: 'linear-gradient(135deg, #648DB3  0%, #5459AC 100%)',
                padding: '10px',
                display: 'flex',
                gap: '1rem',
                borderRadius: '10px',
                alignItems: 'center',
                position: 'relative',
                cursor: 'pointer'
              }}
              onClick={handleTodayTrips}
            >
              <Box>
                <Typography color={'#fff'} fontSize={'1rem'} fontWeight={600}>
                  Refresh
                </Typography>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Icon
                  icon={'ph:arrows-clockwise'}
                  style={{
                    color: '#ffffff',
                    cursor: 'pointer',
                    fontSize: '20px',
                    userSelect: 'none'
                  }}
                  className={`activerIcon ${refresh ? 'refresh' : ''}`}
                />
              </Box>
            </Box> */}
                </Box>

                {(groupData?.length > 0 ||
                  (filter && groupData?.length === 0) ||
                  rows?.length > 0 ||
                  (filter && rows?.length === 0)) && (
                  <Box>
                    <CustomTextField
                      name='search'
                      control={formControl}
                      id='filter-input'
                      placeholder='Search...'
                      value={filter}
                      variant='standard'
                      icon={<SearchOutlinedIcon color='primary' />}
                      onChangeCallback={(e: any) => handleFilterChange(e)}
                    />
                  </Box>
                )}
              </Box>
            </>
          )}

          {isDialog === 'AddContact' && (
            <Dialog
              open={isDialog === 'AddContact'}
              onClose={handleClose}
              PaperProps={{
                sx: {
                  borderRadius: 4,
                  background: 'linear-gradient(145deg, #ffffff, #f0f8ff)',
                  boxShadow: '0px 16px 40px rgba(0, 0, 0, 0.2)',
                  overflow: 'hidden',
                  backdropFilter: 'blur(10px)'
                }
              }}
              BackdropProps={{
                sx: {
                  backgroundColor: 'rgba(0, 0, 0, 0.5)',
                  backdropFilter: 'blur(4px)'
                }
              }}
            >
              <Box
                padding={4}
                width={450}
                component={'form'}
                onSubmit={onsubmit(onChangeNumberSubmit)}
              >
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    marginBottom: 3,
                    paddingBottom: 2,
                    borderBottom: '2px solid #e3f2fd'
                  }}
                >
                  <Icon
                    icon='ph:phone-plus'
                    style={{
                      fontSize: '24px',
                      color: '#1976d2',
                      marginRight: '12px'
                    }}
                  />
                  <Typography
                    sx={{
                      fontWeight: '700',
                      fontSize: '20px',
                      color: '#1976d2'
                    }}
                  >
                    Guest Contact Information
                  </Typography>
                </Box>
                <CustomTextField
                  id='guestName'
                  name='guestName'
                  placeholder='Guest Name'
                  control={formControl}
                  disabled
                  label='Guest Name'
                  defaultValue={selectedTripRow?.guestName || ''}
                  variant='outlined'
                />

                <Controller
                  name='phone'
                  control={formControl}
                  defaultValue={''}
                  rules={{ required: true }}
                  render={({ field }: any) => (
                    <PhoneNoTextField
                      {...field}
                      setValue={setValue}
                      // disableCountry={true}
                      style='share'
                      label='Contact Number'
                      helperText={errors?.phone?.message}
                      error={!!errors?.phone?.message}
                      onChange={(e: any) => {
                        if (e) {
                          const emptySpace = /^.+\s.+$/g;
                          if (e && !emptySpace.test(e)) {
                            handleValidate(e, 'phone');
                          }
                        }
                        phoneTrigger('phone');
                      }}
                    />
                  )}
                />

                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    marginTop: 3,
                    padding: 2,
                    backgroundColor: '#f8fffe',
                    borderRadius: 2,
                    border: '1px solid #e8f5e8'
                  }}
                >
                  <Tooltip
                    title={
                      selectedTripRow?.vehicleNumber === 'Unassigned'
                        ? "Can't send whatsapp for tours without vehicles"
                        : ''
                    }
                  >
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <Icon
                        icon='ic:baseline-whatsapp'
                        style={{
                          fontSize: '24px',
                          color: '#25d366',
                          marginRight: '12px'
                        }}
                      />
                      <Box>
                        <Typography
                          sx={{
                            fontWeight: '600',
                            fontSize: '14px',
                            color: '#333',
                            marginBottom: '2px'
                          }}
                        >
                          Send WhatsApp Message
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: '12px',
                            color: '#666'
                          }}
                        >
                          Enable to send notifications via WhatsApp
                        </Typography>
                      </Box>
                    </Box>
                  </Tooltip>
                  <Controller
                    name='sendWhatsApp'
                    control={formControl}
                    defaultValue={false}
                    render={({ field }) => (
                      <Switch
                        checked={sendWhatsApp}
                        onChange={e => {
                          field.onChange(e.target.checked);
                          setSendWhatsApp(e.target.checked);
                        }}
                        disabled={selectedTripRow?.vehicleNumber === 'Unassigned'}
                        sx={{
                          '& .MuiSwitch-switchBase.Mui-checked': {
                            color: '#ffffff',
                            '&:hover': {
                              backgroundColor: 'rgba(37, 211, 102, 0.08)'
                            }
                          },
                          '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                            backgroundColor: '#25d366',
                            opacity: 1
                          },
                          '& .MuiSwitch-track': {
                            backgroundColor: '#ccc',
                            opacity: 1
                          },
                          '& .MuiSwitch-thumb': {
                            backgroundColor: '#ffffff',
                            boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                          },
                          '& .MuiSwitch-switchBase': {
                            color: '#ffffff',
                            '&:hover': {
                              backgroundColor: 'rgba(0, 0, 0, 0.04)'
                            }
                          }
                        }}
                      />
                    )}
                  />
                </Box>

                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    gap: 2,
                    marginTop: 3,
                    paddingTop: 2,
                    borderTop: '1px solid #e0e0e0'
                  }}
                >
                  <CustomButton
                    category='Cancel'
                    className='cancel'
                    sx={{
                      borderRadius: 3,
                      textTransform: 'none',
                      fontWeight: '600',
                      padding: '10px 24px'
                    }}
                    onClick={() => handleClose()}
                  />
                  <CustomButton
                    category={sendWhatsApp ? 'Save & Send' : 'Save'}
                    className='saveChanges'
                    loading={
                      selectedTripRow?.mode === 'PVT' || selectedTripRow?.mode === 'GRP'
                        ? updatePVTLoading || updateGuestLoading
                        : sicIsLoading || updateGuestLoading
                    }
                    type='submit'
                    sx={{
                      borderRadius: 3,
                      textTransform: 'none',
                      fontWeight: '600',
                      padding: '10px 24px',
                      background: 'linear-gradient(45deg, #1976d2, #42a5f5)',
                      '&:hover': {
                        background: 'linear-gradient(45deg, #1565c0, #1e88e5)'
                      }
                    }}
                  />
                </Box>
              </Box>
            </Dialog>
          )}

          {!hotelGuestView &&
            ((currentDatas['isLoading'] || profileLoading) &&
            (currentDatas['data']?.length === 0 || currentDatas['data'] === null) ? (
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center'
                }}
              >
                <Box className='blue-circle-loader big-screen'>
                  <Box className='blue-circle-spinner'></Box>
                </Box>
              </Box>
            ) : currentDatas['data']?.length > 0 && currentDatas['data'] ? (
              <Box
                sx={{
                  borderRadius: 3,
                  overflow: 'auto',
                  background: 'white',
                  boxShadow: 'none',
                  height: '55vh',
                  scrollbarWidth: 'none',
                  marginTop: { lg: '12px', md: '12px', sm: '12px', xs: '12px' }
                }}
              >
                <CustomDataGrid
                  rows={currentDatas['data']}
                  columns={currentDatas['columns']}
                  type='logistics'
                  onPaginationModelChange={handlePaginationModelChange}
                  pageNo={PageNo}
                  rowCount={currentDatas['count']}
                  loading={currentDatas['isLoading'] && refreshLoader}
                  rowHeight={35}
                  pageSize={PageSize}
                  paginationModel={{
                    page: PageNo && currentDatas['count'] ? PageNo - 1 : 0,
                    pageSize: PageSize ? PageSize : 20
                  }}
                  onRowClick={(id: number, row: any) => {
                    if (isOverview) {
                      handleHotelsandGuestsView(row);
                    }
                  }}
                />
              </Box>
            ) : (
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: 400,
                  background: 'linear-gradient(145deg, #f8f9fa, #ffffff)',
                  textAlign: 'center',
                  padding: 4
                }}
              >
                <Box
                  component='img'
                  src={nodata}
                  alt='No Report Found'
                  sx={{
                    maxWidth: 200,
                    opacity: 0.7,
                    marginBottom: 2
                  }}
                />
                <Typography
                  variant='h6'
                  sx={{
                    color: '#666',
                    fontWeight: '500',
                    marginBottom: 1
                  }}
                >
                  No Trips Scheduled
                </Typography>
                <Typography
                  variant='body2'
                  sx={{
                    color: '#999',
                    maxWidth: 300
                  }}
                >
                  There are no scheduled trips for today.
                </Typography>
              </Box>
            ))}
          {open && (
            <Dialog
              open={open}
              maxWidth='xs'
              fullWidth
              PaperProps={{
                sx: {
                  borderRadius: 3,
                  boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)'
                }
              }}
            >
              <Box component={'form'} onSubmit={vehicelsubmit(onvehicleSubmit)}>
                <DialogTitle sx={{ p: 0 }}>
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      p: 3,
                      borderBottom: '1px solid',
                      borderColor: 'divider'
                    }}
                  >
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                      <Avatar
                        sx={{
                          bgcolor: 'primary.light',
                          color: 'primary.main',
                          width: 40,
                          height: 40
                        }}
                      >
                        <DirectionsCar />
                      </Avatar>
                      <Box>
                        <Typography variant='h6' component='h2' sx={{ fontWeight: 600 }}>
                          Select Vehicle
                        </Typography>
                        <CustomRadioButton
                          name='vehicle'
                          control={control}
                          radiobutton1='Internal Vehicle'
                          radiobutton2='External Vehicle'
                          value={getValues('vehicle')}
                          value1='internal'
                          value2='external'
                          onChangeCallback={(e: any) => {
                            internalReset();
                            externalReset();
                            clearExternalVehicleErrors();
                            clearErrors();

                            setVehicleValue('vehicle', e.target.value);

                            clearErrors();

                            if (e.target.value === 'internal') {
                              setExternal(false);
                            } else {
                              setExternal(true);
                            }
                            let overview = null;
                            if (['SIC', 'TSIC'].includes(selectedRow?.mode)) {
                              overview = selectedRow?.standardTourOverview;
                            } else if (['PVT', 'GRP'].includes(selectedRow?.mode)) {
                              overview = selectedRow?.customTourOverview;
                            }
                            const payload = {
                              autoplannerID: selectedRow.date,
                              tripMode: selectedRow?.mode,
                              tourName: selectedRow?.tourName,
                              totalPassengers: selectedRow?.totalGuests,
                              vehicleNumber: selectedRow?.vehicleNumber,
                              isCurrentSchedule: true,
                              journeyId: overview?.journeyId || overview?.journeyId || ''
                            };
                            if (e.target.value !== 'external') {
                              dispatch(getStandardVehicles(payload));
                            }
                          }}
                        />
                      </Box>
                    </Box>
                    <IconButton
                      onClick={handleCancel}
                      sx={{
                        color: 'text.secondary',
                        '&:hover': {
                          color: 'text.primary'
                        }
                      }}
                    >
                      <Close />
                    </IconButton>
                  </Box>
                </DialogTitle>

                <DialogContent sx={{ p: 3, pt: 4 }}>
                  {!external ? (
                    <Box sx={{ mb: 2 }}>
                      <CustomSelect
                        isDisabled={dropdownLoading}
                        id='vehicleNumber'
                        control={control}
                        label='Vehicle Number'
                        name='vehicleNumber'
                        placeholder='Vehicle number'
                        options={
                          dropdownLoading ? defaultVehilceNumber : standardVehicles
                        }
                        loading={dropdownLoading}
                        onChanges={(id: any, value: any) => {
                          setVehicleValue('driverName', '');
                          dispatch(clearDriverNames());

                          const payload = {
                            autoplannerID: selectedRow.date,
                            tripMode: selectedRow?.mode,
                            tourName: selectedRow?.tourName,
                            totalPassengers: selectedRow?.totalGuests,
                            vehicleNumber: value?.id,
                            isCurrentSchedule: true,
                            journeyId:
                              selectedRow?.customTourOverview?.journeyId ||
                              selectedRow?.standardTourOverview?.journeyId ||
                              ''
                          };
                          if (value) {
                            dispatch(getStandardDriverNames(payload));
                          }
                        }}
                      />
                      <CustomSelect
                        isDisabled={DriverNameLoading || !getValues('vehicleNumber')}
                        id='drivername'
                        control={control}
                        label='Driver Name'
                        name='driverName'
                        placeholder='Driver name'
                        options={
                          DriverNameLoading ? defaultDriverName : driverNameDropdown
                        }
                        loading={DriverNameLoading}
                        onChanges={(_: any, value: any) => {
                          setVehicleValue('driverName', value?.id);
                        }}
                      />
                    </Box>
                  ) : (
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                      <Box>
                        <CustomTextField
                          id='vehicleNumber'
                          control={control}
                          name='vehicleNumber'
                          label='Vehicle Number'
                          maxlength={20}
                          placeholder='Vehicle number'
                          onChangeCallback={e => {
                            setVehicleValue('vehicleNumber', e);
                          }}
                        />
                      </Box>

                      <Box>
                        <CustomTextField
                          id='driverName'
                          control={control}
                          name='driverName'
                          label='Driver Name'
                          placeholder='Driver name'
                          maxlength={60}
                          onChangeCallback={e => {
                            setVehicleValue('driverName', e);
                          }}
                        />
                      </Box>
                      <Box>
                        <CustomTextField
                          id='count'
                          control={control}
                          type='number'
                          name='passengerCount'
                          isDecimal
                          label='Seating Capacity'
                          placeholder='Seating capacity'
                          onChangeCallback={e => {
                            setVehicleValue('passengerCount', e);
                            clearErrors('passengerCount');
                          }}
                        />
                      </Box>

                      <Box>
                        <Controller
                          name='driverNumber'
                          control={control}
                          rules={{ required: true }}
                          render={({ field }) => (
                            <PhoneNoTextField
                              {...field}
                              setValue={setVehicleValue}
                              country='sg'
                              disableCountry={true}
                              style='share'
                              label='Contact Number'
                              error={Boolean(vehicleErrors?.driverNumber?.message)}
                              helperText={vehicleErrors?.driverNumber?.message}
                              onChange={(e: any) => {
                                if (e) {
                                  const emptySpace = /^.+\s.+$/g;
                                  if (e && !emptySpace.test(e)) {
                                    handleValidate(e, 'driverNumber');
                                  } else {
                                    setVehicleValue('driverNumber', '');
                                  }
                                }
                                trigger('driverNumber');
                              }}
                            />
                          )}
                        />
                        {/* {errors?.phone?.message && (
                  <Box>
                    <CustomTextField
                      id='count'
                      control={control}
                      type='number'
                      name='passengerCount'
                      label='Seat Capacity'
                      placeholder='Count'
                      onChangeCallback={e => {
                        setVehicleValue('passengerCount', e);
                        clearErrors('passengerCount');
                      }}
                    />
                  </Box>

                  <Box>
                    <Controller
                      name='driverNumber'
                      control={control}
                      rules={{ required: true }}
                      render={({ field }) => (
                        <PhoneNoTextField
                          {...field}
                          setValue={setVehicleValue}
                          style='share'
                          label='Contact Number'
                          error={Boolean(vehicleErrors?.driverNumber?.message)}
                          helperText={vehicleErrors?.driverNumber?.message}
                          onChange={(e: any) => {
                            if (e) {
                              handleValidate(e);
                            }
                            trigger('driverNumber');
                          }}
                        />
                      )}
                    />
                    {/* {errors?.phone?.message && (
                    <Typography
                      sx={{
                        color: '#d32f2f',
                        display: 'flex',
                        justifyContent: 'flex-start',
                        fontSize: '12px',
                        fontWeight: 300,
                        mt: 0.5,
                        ml: 1
                      }}
                    >
                      {(errors as any).phone?.message}
                    </Typography>
                  )} */}
                      </Box>
                    </Box>
                  )}
                </DialogContent>

                {/* Footer */}
                <DialogActions
                  sx={{
                    borderTop: '1px solid',
                    borderColor: 'divider',
                    bgcolor: 'grey.50',
                    gap: 1.5,
                    p: 3
                  }}
                >
                  <Button
                    onClick={handleCancel}
                    // disabled={dropdownLoading}
                    variant='outlined'
                    sx={{
                      px: 4,
                      py: 1.5,
                      minWidth: 100,
                      height: 42,
                      borderRadius: 2,
                      textTransform: 'none',
                      fontWeight: 600,
                      fontSize: '0.925rem',
                      borderColor: 'grey.300',
                      color: 'text.primary',
                      borderWidth: 1.5,
                      // '&:hover': {
                      //   borderColor: 'primary.main',
                      //   bgcolor: 'primary.light',
                      //   color: 'primary.main',
                      //   borderWidth: 1.5
                      // },
                      '&:disabled': {
                        opacity: 0.5,
                        borderColor: 'grey.300'
                      },
                      transition: 'all 0.2s ease-in-out'
                    }}
                  >
                    Cancel
                  </Button>
                  <Button
                    disabled={onsubmitIsLoading || PVTGRPUpdateLoading}
                    variant='contained'
                    type='submit'
                    startIcon={
                      onsubmitIsLoading || PVTGRPUpdateLoading ? (
                        <CircularProgress size={16} color='inherit' />
                      ) : (
                        <Check />
                      )
                    }
                    sx={{
                      px: 4,
                      py: 1.5,
                      minWidth: 120,
                      height: 42,
                      borderRadius: 2,
                      textTransform: 'none',
                      fontWeight: 600,
                      fontSize: '0.925rem',
                      bgcolor: 'primary.main',
                      boxShadow: '0 2px 8px rgba(25, 118, 210, 0.3)',
                      '&:hover': {
                        bgcolor: 'primary.dark',
                        boxShadow: '0 4px 12px rgba(25, 118, 210, 0.4)',
                        transform: 'translateY(-1px)'
                      },
                      '&:active': {
                        transform: 'translateY(0)'
                      },
                      '&:disabled': {
                        opacity: 0.6,
                        boxShadow: 'none'
                      },
                      transition: 'all 0.2s ease-in-out'
                    }}
                  >
                    {onsubmitIsLoading || PVTGRPUpdateLoading ? 'Saving...' : 'Save'}
                  </Button>
                </DialogActions>
              </Box>
            </Dialog>
          )}
          {hotelGuestView && (
            <>
              <CustomButton
                className='cancel'
                category='Back'
                startIcon={<ArrowBackIcon />}
                onClick={() => {
                  setCallApi(false);
                  setHotelGuestView(null);
                }}
              />

              <TourDashboard selectedTour={hotelGuestView} />
            </>
          )}
          {isDialog === 'whatsapp' && (
            <Dialog open={isDialog === 'whatsapp'}>
              <Box
                sx={{
                  textAlign: 'center',
                  padding: '5%',
                  minWidth: '350px'
                }}
              >
                <Typography>{constant.ShareToWhatsapp}</Typography>
                <Box
                  sx={{
                    paddingTop: '5%',
                    display: 'flex',
                    flexDirection: 'row',
                    gap: '15px',
                    justifyContent: 'center'
                  }}
                >
                  <CustomButton
                    className='cancel'
                    category='Cancel'
                    variant='outlined'
                    onClick={() => {
                      setIsDialog('');
                      setCallApi(false);
                    }}
                  />
                  <CustomButton
                    className='saveChanges'
                    category={'Send'}
                    icon='mynaui:send-solid'
                    loading={sendwhatsapp?.isLoading}
                    onClick={handleSendWhatsapp}
                  />
                </Box>
              </Box>
            </Dialog>
          )}

          {isDialog == 'Nocontact' && (
            <Dialog
              open={isDialog == 'Nocontact'}
              onClose={handleClose}
              maxWidth='xl'
              fullWidth
              PaperProps={{
                sx: {
                  width: '90vw',
                  maxWidth: '1400px',
                  height: '85vh',
                  maxHeight: '800px',
                  borderRadius: '16px',
                  boxShadow: '0 24px 48px rgba(0, 0, 0, 0.15)',
                  background: 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)',
                  border: '1px solid rgba(226, 232, 240, 0.8)',
                  overflow: 'hidden'
                }
              }}
            >
              <Box
                sx={{
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  position: 'relative'
                }}
              >
                <Box
                  sx={{
                    padding: '10px 32px ',
                    borderBottom: '1px solid #e2e8f0',
                    background: 'linear-gradient(90deg, #f1f5f9 0%, #ffffff 100%)',
                    position: 'relative',
                    flexShrink: 0
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'flex-start',
                      gap: '12px',
                      padding: '12px 16px',
                      backgroundColor: '#fffbeb',
                      border: '1px solid #fed7aa',
                      borderRadius: '12px',
                      marginBottom: '16px',
                      boxShadow: '0 2px 4px rgba(251, 191, 36, 0.1)'
                    }}
                  >
                    <Box
                      sx={{
                        width: '16px',
                        height: '16px',
                        borderRadius: '50%',
                        backgroundColor: '#f59e0b',
                        color: '#ffffff',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '12px',
                        fontWeight: 'bold',
                        flexShrink: 0,
                        marginTop: '2px'
                      }}
                    >
                      !
                    </Box>

                    <Box sx={{ flex: 1 }}>
                      <Typography
                        variant='body1'
                        sx={{
                          color: '#92400e',
                          fontSize: '12px',
                          lineHeight: 1.6,
                          fontWeight: 500,
                          margin: 0
                        }}
                      >
                        Some of these bookings do not have contact numbers. You may either
                        add the missing numbers or proceed by clicking the 'Skip' button
                        to send WhatsApp messages to the bookings with valid contact
                        numbers.
                      </Typography>
                    </Box>

                    <CustomButton
                      className='skip'
                      category='Skip & Send'
                      onClick={() => {
                        handleSkip();
                        setCallApi(false);
                      }}
                      sx={{
                        minWidth: '100px',
                        height: '36px',
                        borderRadius: '6px',
                        textTransform: 'none',
                        fontWeight: 600,
                        fontSize: '0.825rem',
                        border: '2px solid #f59e0b',
                        color: '#f59e0b',
                        backgroundColor: '#ffffff',
                        boxShadow: '0 2px 4px rgba(245, 158, 11, 0.15)',
                        '&:hover': {
                          backgroundColor: '#fef3c7',
                          borderColor: '#d97706',
                          color: '#d97706',
                          transform: 'translateY(-1px)',
                          boxShadow: '0 4px 8px rgba(245, 158, 11, 0.25)'
                        },
                        transition: 'all 0.2s ease'
                      }}
                    />
                  </Box>
                </Box>
                <Box
                  sx={{
                    flex: 1,
                    // padding: 'px 28px',
                    display: 'flex',
                    flexDirection: 'column',
                    minHeight: 0,
                    overflow: 'hidden'
                  }}
                >
                  <Box
                    sx={{
                      height: '200vh',
                      borderRadius: '12px',
                      border: '1px solid #e2e8f0',
                      boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
                      background: '#ffffff',
                      overflow: 'auto'
                    }}
                  >
                    <Box
                      key={invalidRows?.length}
                      sx={{
                        height: '100%',
                        width: '100%',
                        '& .MuiDataGrid-root': {
                          border: 'none',
                          height: '100%'
                        },
                        '& .MuiDataGrid-main': {
                          overflow: 'visible'
                        },
                        '& .MuiDataGrid-virtualScroller': {
                          overflow: 'auto !important',
                          height: 'auto !important'
                        },
                        '& .MuiDataGrid-footerContainer': {
                          minHeight: '52px',
                          borderTop: '1px solid #e2e8f0',
                          backgroundColor: '#f8fafc'
                        },
                        '& .MuiDataGrid-row:hover': {
                          backgroundColor: '#f1f5f9'
                        }
                      }}
                    >
                      <CustomDataGrid
                        rows={invalidRows}
                        columns={invalidColumns}
                        loading={isLoading}
                        rowHeight={40}
                        type={'noPageNation'}
                        paginationMode={'client'}
                      />
                    </Box>
                  </Box>
                </Box>

                <Box
                  sx={{
                    padding: '20px 32px 24px',
                    borderTop: '1px solid #e2e8f0',
                    background: 'linear-gradient(90deg, #ffffff 0%, #f8fafc 100%)',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    flexShrink: 0
                  }}
                >
                  <Box sx={{ display: 'flex', gap: '16px' }}>
                    <CustomButton
                      className='cancel'
                      category='Cancel'
                      onClick={() => {
                        reset();
                        handleInvalidClose();
                        setCallApi(false);
                      }}
                      sx={{
                        minWidth: '120px',
                        height: '44px',
                        borderRadius: '8px',
                        textTransform: 'none',
                        fontWeight: 500,
                        fontSize: '0.925rem',
                        border: '2px solid #e2e8f0',
                        color: '#64748b',
                        backgroundColor: '#ffffff',
                        '&:hover': {
                          backgroundColor: '#f8fafc',
                          borderColor: '#cbd5e1',
                          transform: 'translateY(-1px)',
                          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)'
                        },
                        transition: 'all 0.2s ease'
                      }}
                    />
                    <CustomButton
                      className='saveChanges'
                      type='submit'
                      disabled={invalidRows?.some((item: any) => item?.isError)}
                      category='Update'
                      onClick={() => handleUpdateContact()}
                      loading={updateGuestLoading}
                      sx={{
                        minWidth: '120px',
                        height: '44px',
                        borderRadius: '8px',
                        textTransform: 'none',
                        fontWeight: 600,
                        fontSize: '0.925rem',
                        background: 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)',
                        color: '#ffffff',
                        boxShadow: '0 4px 12px rgba(59, 130, 246, 0.3)',
                        '&:hover': {
                          background: 'linear-gradient(135deg, #2563eb 0%, #1e40af 100%)',
                          transform: 'translateY(-2px)',
                          boxShadow: '0 8px 20px rgba(59, 130, 246, 0.4)'
                        },
                        transition: 'all 0.2s ease',
                        '&:disabled': {
                          background: '#94a3b8',
                          transform: 'none',
                          boxShadow: 'none'
                        }
                      }}
                    />
                  </Box>
                  {invalidRows?.some((item: any) => item?.isError) && (
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                      <Box
                        sx={{
                          width: 15,
                          height: 15,
                          borderRadius: '50%',
                          backgroundColor: '#ff07078c'
                        }}
                      />
                      <Box>
                        <p
                          style={{
                            color: '#5e5c5cff',
                            fontSize: '14px',
                            fontWeight: 600,
                            fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif'
                          }}
                        >
                          Invalid Contact Numbers:{' '}
                          {invalidRows?.filter((item: any) => item?.isError)?.length}
                        </p>
                      </Box>
                    </Box>
                  )}
                </Box>
              </Box>
            </Dialog>
          )}
        </Box>
      ) : (
        <Box>
          {isViewAdhoc && (
            <ViewAdhocRequests
              onClose={() => setIsDialog('')}
              currentDatas={ViewAdhocReqData}
              columns={adhocReqColumns}
              PageNo={PageNo}
              PageSize={PageSize}
              refreshLoader={refreshLoader}
              handlePaginationModelChange={handlePaginationAdhocReq}
              handleHotelsandGuestsView={handleHotelsandGuestsView}
              setSelectedTripRow={setSelectedTripRow}
              setIsDialog={setIsDialog}
              setIsViewAdhoc={setIsViewAdhoc}
              setCallApi={setCallApi}
            />
          )}
        </Box>
      )}
      {isDialog === 'adhoc' && (
        <AddAdhocTrip
          setCallApi={setCallApi}
          isOpen={isDialog === 'adhoc'}
          setIsOpen={setIsDialog}
          selectedRow={selectedTripRow}
          setSelectedRow={setSelectedTripRow}
          pageDetailss={{ pageNo: PageNo, pageSize: PageSize }}
          Agents={agentNames}
          autoplannerID={autoplannerID}
          Routes={[]}
          isViewAdhoc={isViewAdhoc}
          setBadgeCount={setBadgeCount}
        />
      )}
      {isDialog === 'delete' && (
        <Dialog open={isDialog === 'delete'}>
          <Box
            sx={{
              textAlign: 'center',
              padding: '5%',
              minWidth: '350px'
            }}
          >
            <Typography>Are you sure want to delete this booking?</Typography>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                paddingTop: '5%',
                justifyContent: 'center'
              }}
            >
              <Box sx={{ marginRight: '12px' }}>
                <CustomButton
                  className='saveChanges'
                  loading={AutoPlannerDeleteTripLoading}
                  category='Yes'
                  onClick={() => {
                    handleDeleteDriver();
                  }}
                />
              </Box>
              <CustomButton
                className='cancel'
                category='No'
                onClick={() => {
                  setIsDialog('');
                }}
              />
            </Box>
          </Box>
        </Dialog>
      )}
    </>
  );
};

export default TodayTours;
